<template>
  <span>
    <div
      class="row pos-rel pt-5 mt-4"
      :class="{ 'message-head': !chatLoader, 'message-head-without-data': chatLoader }"
    >
      <div
      style="height: 100vh;"
        class="row message overflow-x-hidden pos-rel"
        v-if="
          chatLoader &&
          ((pageType == 'chatpage' && roomlist.length > 0) || pageType == 'contractpage')
        "
      >
        <div class="pt-4 message-loader-box rounded h-100">
          <div class="d-flex align-items-start p-2 mt-3 mb-2">
            <!-- Image Placeholder -->
            <div class="image-placeholder shimmer rounded-lg me-3"></div>
            <!-- Text Placeholders -->
            <div class="flex-grow-1">
              <div class="third-title-placeholder shimmer mb-2"></div>
              <div class="subtitle-placeholder shimmer mb-2"></div>
              <div class="third-description-placeholder shimmer"></div>
            </div>
          </div>
          <div class="d-flex align-items-start p-2 mt-3 mb-2">
            <!-- Image Placeholder -->
            <div class="image-placeholder shimmer rounded-lg me-3"></div>
            <!-- Text Placeholders -->
            <div class="flex-grow-1">
              <div class="single-title-placeholder shimmer mb-2"></div>
            </div>
          </div>
          <div class="d-flex align-items-start p-2 mt-3 mb-2">
            <!-- Image Placeholder -->
            <div class="image-placeholder shimmer rounded-lg me-3"></div>
            <!-- Text Placeholders -->
            <div class="flex-grow-1">
              <div class="second-title-placeholder shimmer mb-2"></div>
              <div class="subtitle-placeholder shimmer mb-2"></div>
            </div>
          </div>
          <div class="d-flex align-items-start p-2 mt-3 mb-2">
            <!-- Image Placeholder -->
            <div class="image-placeholder shimmer rounded-lg me-3"></div>
            <!-- Text Placeholders -->
            <div class="flex-grow-1">
              <div class="third-title-placeholder shimmer mb-2"></div>
              <div class="subtitle-placeholder shimmer mb-2"></div>
              <div class="third-description-placeholder shimmer"></div>
            </div>
          </div>
          <div class="d-flex align-items-start p-2 mt-3 mb-2">
            <!-- Image Placeholder -->
            <div class="image-placeholder shimmer rounded-lg me-3"></div>
            <!-- Text Placeholders -->
            <div class="flex-grow-1">
              <div class="third-description-placeholder shimmer mb-2"></div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="row message overflow-x-hidden pos-rel pt-5"
        @scroll="!chatLoader ? handleScroll($event) : ''"
        id="conversation"
        ref="msgContainer"
        :style="{ bottom: `${conversationHeight}px!important` }"
        @dragover.prevent="onDragOver"
        @dragleave="onDragLeave"
        @drop.prevent="onDrop"
      >
      <div class="no-internet-connecion updating-conversation" v-if="!messageUpCycleData.status">
        updating conversation....
      </div>

        <span id="message-list-container-fixed" v-if="messagelist.length > 0  || localStorageMessageList.length > 0">
          <div class="row message-body" v-for="(msgs, index) in messagelist" :key="index">
            <div class="col-sm-12 mb-2">
              <div class="unread-time-wrapper">
                <div class="pos-rel time-wrap">
                  <span class="time pos-absolute">{{ msgs.key }}</span>
                </div>
              </div>
            </div>

            <div class="content-holder mt-2" v-for="(msg, ind) in msgs.value" :key="ind">
              <div class="d-flex align-items-center" v-if="msg.key.type != 4 && msg.key.type != 5 && msg.key.type != 6">
                <div class="img-holder w-10">
                  <div class="heading-avatar-icon">
                    <img :src="msg.key.profile_picture_path" />
                    <span
                      class="status-icon"
                      :class="'status-' + msg.key.sended_by"
                    ></span>
                  </div>
                </div>
                <div class="content-holder d-flex align-items-center">
                  <p class="mb-0 ml-2 fw-600">
                    {{ msg.key.first_name }} {{ msg.key.last_name }}
                  </p>
                  <span class="msg-time ml-2">{{
                    convertToLocalTime(msg.key.time)
                  }}</span>
                </div>
              </div>
              <div v-for="(messages, mindex) in msg.value"
                :key="mindex"
                :id="mindex"
                :class="
                  messages.type == 3
                  ? 'pdf-div-css'
                  : messages.type == 2
                  ? 'chat-img-div-css'
                  : ''
                "
              >
                <!-- {{'index'+ mindex}} -->
                <div class="mb-2 pl-50" v-if="messages.type == 1">
                  <!-- {{ 'v-if'+messages.type }} -->
                  <!-- {{ consolelog('messages-v-if'+mindex,messages) }} -->
                  <div class="single-msg" id="single-msg">
                    <span v-if="messages.type == 1" class="msg-span"> 
                      <!-- <read-more more-str="Read more" :text="getHtmlContent(messages.message)" link="#" less-str="Read less" :max-chars="300"></read-more> -->
                      <template v-if="messages.is_deleted == 0" >
                        <div :style="messages.is_updated == 1 ? 'display:flex;gap:5px':''">
                          
                          <p
                            class="line-break-auto"
                            v-html="getHtmlContent(messages.message)"
                          ></p>
                          <span class="line-break-auto" v-if="messages.is_updated == 1"> 
                            <svg xmlns="http://www.w3.org/2000/svg" width="15px" height="15px" viewBox="0 0 24 24" fill="none">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M15.8787 3.70705C17.0503 2.53547 18.9498 2.53548 20.1213 3.70705L20.2929 3.87862C21.4645 5.05019 21.4645 6.94969 20.2929 8.12126L18.5556 9.85857L8.70713 19.7071C8.57897 19.8352 8.41839 19.9261 8.24256 19.9701L4.24256 20.9701C3.90178 21.0553 3.54129 20.9554 3.29291 20.7071C3.04453 20.4587 2.94468 20.0982 3.02988 19.7574L4.02988 15.7574C4.07384 15.5816 4.16476 15.421 4.29291 15.2928L14.1989 5.38685L15.8787 3.70705ZM18.7071 5.12126C18.3166 4.73074 17.6834 4.73074 17.2929 5.12126L16.3068 6.10738L17.8622 7.72357L18.8787 6.70705C19.2692 6.31653 19.2692 5.68336 18.8787 5.29283L18.7071 5.12126ZM16.4477 9.13804L14.8923 7.52185L5.90299 16.5112L5.37439 18.6256L7.48877 18.097L16.4477 9.13804Z" fill="#00000045"/>
                            </svg>
                          </span>  
                        </div>
                        <!-- <span class="edited-msg-time" v-if="messages.is_updated == 1">Edited:{{convertToLocalTime(messages.updated_at)}}</span> -->
                      </template>  
                      <div  v-else>
                        <span class="fz-600"
                          ><i>{{
                            messages.sended_by ==
                            $store.state.currentUserData.login_master_id
                              ? "You deleted this message."
                              : "This message was deleted."
                          }}</i></span
                        >
                      </div>
                      <!-- <span class="msg-time ml-2">{{ messages.time }}</span> -->
                    </span>
                    <template  v-if="checkUserEditDeletePermission(messages) && messages.is_deleted == 0">
                      <div class="dropdown-option 2" >
                        
                        <div class="button-container">
                          <div class="edit-container" style="position: relative;">
                              <button
                                  class="icon-button edit-button"
                                  aria-label="Edit"
                                  @click="
                                    updateMessage.editMessage = true;
                                    sendChat.message = messages.message;
                                    updateMessage.chatIndex = index;
                                    updateMessage.chatData = messages;
                                    updateMessage.chatParentIndex = ind;
                                    updateMessage.chatChildIndex = mindex;
                                  "
                                  :disabled="checkTimeForEditBtn(messages.updated_at)" 
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    width="14"
                                    height="14"
                                  >
                                    <path
                                      d="M3 17.25v3.75h3.75L14.81 10.94l-3.75-3.75L3 17.25zM20.71 6.04a1 1 0 0 0 0-1.41l-3.29-3.29a1 1 0 0 0-1.41 0l-2.46 2.46 4.7 4.7 2.46-2.46a1 1 0 0 0 0-1.41z"
                                    />
                                  </svg>
                                </button>
                                <div class="no-internet-tooltip edit-ref" v-if="checkTimeForEditBtn(messages.updated_at)">
                                    Editing is only available for 1 hour 
                                </div>
                          </div>
                          <button
                            class="icon-button delete-button"
                            aria-label="Delete"
                            @click="
                              deleteMsgSetVar(
                                messages.chat_id,
                                index,
                                ind,
                                mindex,
                                $event,
                                1
                              )
                            "
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              width="14"
                              height="14"
                            >
                              <path
                                d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm3-5h2v-2H9v2zm4 0h2v-2h-2v2zm5-9h-4.5L14 1H10l-1.5 3H5v2h14V5z"
                              />
                            </svg>
                          </button>
                        </div>
                      </div>
                    </template>  
                  </div>
                </div>
                <div class="inline-block mb-2 parent img-parent" v-else-if="messages.type == 2">
                  <!-- {{ 'v-else-if'+mindex+messages.type }} -->
                  <!-- {{ messages.data }} -->
                  <template v-for="(documents, docIndex) in messages.data">
                    <div
                      class="msg-span file-span pos-rel chat-img-div-css mr-4"
                      id="img-div"
                      :key="docIndex"
                      v-if="documents.is_deleted == 0"
                    >
                      <!-- {{ documents }} -->
                      <span class="msg-span p-0">
                        <img
                          v-lazy="documents.thumb"
                          @error="defaultImage"
                          width="100"
                          height="100"
                          @click="setSlider(messages.data), setImage(docIndex)"
                          v-b-modal.modal-image-slider
                        />
                        <!-- <span class="msg-time">{{ documents.time }}</span> -->
                      </span>
                      <div class="dropdown-option 3" v-if="documents.type == 2 && checkUserEditDeletePermission(documents) && documents.is_deleted == 0">
                        <div class="button-container">
                          <button
                            class="icon-button download-button"
                            aria-label="Download"
                            @click="
                              downloadFile(
                                documents.media_withoutbasepath,
                                documents.file_name != '' && documents.file_name != null
                                  ? documents.file_name
                                  : documents.message
                              )
                            "
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              class="bi bi-download"
                              viewBox="0 0 16 16"
                            >
                              <path
                                d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5"
                              />
                              <path
                                d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z"
                              />
                            </svg>
                          </button>
                          <button
                            class="icon-button delete-button"
                            aria-label="Delete"
                            v-if="
                              $store.state.currentUserData.login_master_id ==
                              documents.sended_by
                            "
                            v-b-modal.confirm-modal
                            @click="
                              deleteMsgSetVar(
                                documents.chat_id,
                                index,
                                ind,
                                mindex,
                                docIndex,
                                2
                              )
                            "
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              width="14"
                              height="14"
                            >
                              <path
                                d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm3-5h2v-2H9v2zm4 0h2v-2h-2v2zm5-9h-4.5L14 1H10l-1.5 3H5v2h14V5z"
                              />
                            </svg>
                          </button>
                        </div>
                      </div>
                      
                    </div>
                    <div class="mb-3" v-else  :key="docIndex">
                      <span class="bg-grey p-2 br-10 text-muted"
                        ><i>{{
                          messages.sended_by ==
                          $store.state.currentUserData.login_master_id
                            ? "You removed this message"
                            : "Message Was Removed"
                        }}</i></span
                      >
                    </div>
                  </template>
                </div>
                <div v-else-if="messages.type == 3" class="parent file-parent">
                  <template v-for="(documents, docIndex) in messages.data">
                    <div
                      class="msg-span file-span pos-rel pdf-div-css"
                      :key="docIndex"
                      v-if="documents.is_deleted == 0"
                      :id="`file-div`"
                    >
                      <a href="javascript:void(0)" class="text-black d-block">
                        <div class="d-flex align-items-center">
                          <div
                            class="br-10 bg-white p-2 mr-2"
                            v-if="
                              documents.file_type == 'image/png' ||
                              documents.file_type == 'image/jpeg'
                            "
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              fill="#c10000"
                              class="bi bi-filetype-pdf"
                              viewBox="0 0 16 16"
                            >
                              <path
                                fill-rule="evenodd"
                                d="M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM1.6 11.85H0v3.999h.791v-1.342h.803q.43 0 .732-.173.305-.175.463-.474a1.4 1.4 0 0 0 .161-.677q0-.375-.158-.677a1.2 1.2 0 0 0-.46-.477q-.3-.18-.732-.179m.545 1.333a.8.8 0 0 1-.085.38.57.57 0 0 1-.238.241.8.8 0 0 1-.375.082H.788V12.48h.66q.327 0 .512.181.185.183.185.522m1.217-1.333v3.999h1.46q.602 0 .998-.237a1.45 1.45 0 0 0 .595-.689q.196-.45.196-1.084 0-.63-.196-1.075a1.43 1.43 0 0 0-.589-.68q-.396-.234-1.005-.234zm.791.645h.563q.371 0 .609.152a.9.9 0 0 1 .354.454q.118.302.118.753a2.3 2.3 0 0 1-.068.592 1.1 1.1 0 0 1-.196.422.8.8 0 0 1-.334.252 1.3 1.3 0 0 1-.483.082h-.563zm3.743 1.763v1.591h-.79V11.85h2.548v.653H7.896v1.117h1.606v.638z"
                              />
                            </svg>
                          </div>

                          <div
                            class="br-10 bg-white p-2 mr-2"
                            v-else-if="documents.file_type == 'application/pdf'"
                          >
                          <svg fill="#C00001" height="40px" width="40px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 482.14 482.14" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <path d="M142.024,310.194c0-8.007-5.556-12.782-15.359-12.782c-4.003,0-6.714,0.395-8.132,0.773v25.69 c1.679,0.378,3.743,0.504,6.588,0.504C135.57,324.379,142.024,319.1,142.024,310.194z"></path> <path d="M202.709,297.681c-4.39,0-7.227,0.379-8.905,0.772v56.896c1.679,0.394,4.39,0.394,6.841,0.394 c17.809,0.126,29.424-9.677,29.424-30.449C230.195,307.231,219.611,297.681,202.709,297.681z"></path> <path d="M315.458,0H121.811c-28.29,0-51.315,23.041-51.315,51.315v189.754h-5.012c-11.418,0-20.678,9.251-20.678,20.679v125.404 c0,11.427,9.259,20.677,20.678,20.677h5.012v22.995c0,28.305,23.025,51.315,51.315,51.315h264.223 c28.272,0,51.3-23.011,51.3-51.315V121.449L315.458,0z M99.053,284.379c6.06-1.024,14.578-1.796,26.579-1.796 c12.128,0,20.772,2.315,26.58,6.965c5.548,4.382,9.292,11.615,9.292,20.127c0,8.51-2.837,15.745-7.999,20.646 c-6.714,6.32-16.643,9.157-28.258,9.157c-2.585,0-4.902-0.128-6.714-0.379v31.096H99.053V284.379z M386.034,450.713H121.811 c-10.954,0-19.874-8.92-19.874-19.889v-22.995h246.31c11.42,0,20.679-9.25,20.679-20.677V261.748 c0-11.428-9.259-20.679-20.679-20.679h-246.31V51.315c0-10.938,8.921-19.858,19.874-19.858l181.89-0.19v67.233 c0,19.638,15.934,35.587,35.587,35.587l65.862-0.189l0.741,296.925C405.891,441.793,396.987,450.713,386.034,450.713z M174.065,369.801v-85.422c7.225-1.15,16.642-1.796,26.58-1.796c16.516,0,27.226,2.963,35.618,9.282 c9.031,6.714,14.704,17.416,14.704,32.781c0,16.643-6.06,28.133-14.453,35.224c-9.157,7.612-23.096,11.222-40.125,11.222 C186.191,371.092,178.966,370.446,174.065,369.801z M314.892,319.226v15.996h-31.23v34.973h-19.74v-86.966h53.16v16.122h-33.42 v19.875H314.892z"></path> </g> </g></svg>
                          </div>

                          <div
                            class="br-10 bg-white p-2 mr-2"
                            v-else-if="
                              documents.file_type ==
                              'application\/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                            "
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              fill="#36d38a"
                              class="bi bi-file-earmark-excel"
                              viewBox="0 0 16 16"
                            >
                              <path
                                d="M5.884 6.68a.5.5 0 1 0-.768.64L7.349 10l-2.233 2.68a.5.5 0 0 0 .768.64L8 10.781l2.116 2.54a.5.5 0 0 0 .768-.641L8.651 10l2.233-2.68a.5.5 0 0 0-.768-.64L8 9.219l-2.116-2.54z"
                              />
                              <path
                                d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z"
                              />
                            </svg>
                          </div>

                          <div
                            class="br-10 bg-white p-2 mr-2"
                            v-else-if="documents.file_type == 'application/zip'"
                          >
                          <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACn0lEQVR4nO2VQWjTUByHX7aJ7iaKgjqxA6UIMp1D6KE7DivzoiBMFEYRQdSD7qAiwibVTURUxFFGd3GgggOPnoTtMJWhuK5r11rtDlaEMFDRoUNcfpLXLU2aNGmX995E8ofv0vTwfS//vhLijTfe/P+DHGlfyJFPygxB1eSMfBmQxoQHLMyQvBtpPfIVSXyE4kLYKkDla0x6tXIBVQgrH4wsBQiNUFwI2wXIoiLcCBt4bw6QRUS4ES7FKkBWIwY4RrgRrjRA5hnhRlgjW8AuQOYVsSzprDWzvZJzxCBh+z/hRriU+ZEViFBcSivvqiBThH1AloN0pjzsAgQJK0IDlrkWtqSNsA3gIZwxS6tgEXYBgoShZ5pngE7owe2tOHFsj4mfiVpcOrsT3ef9VPJpdJP27Ey4Cf0RH368rTNJ62EXYHOio4/WI3rdR+nu8iMYDOJ0uAl/UgQdh1sQPtpM5WI3ttFn/ZFG9Cx+r/fCDpO08IClNfidlHCqczdCbQF8HltDpa0C8qP1VK49FEBnR3P5gBSvgLQ193oaqeDzoQ3aSmgB0wSxvkLAs8GNGL6/Ga2tQfRd1L2BlBl2AQ4/vJdP1lGhm5e3G07RKkBlf1sAV7v8+P66zlKcS4DlTZEmkF+sputw/Mhe/IrXOAbkR+ptpaGSLMAswO6mOHdyFxU7dHCf4Raae1NbDEg5BCStYRdgc1M8vNOA6DVfgUiR+YkaDN1qwOO7W6jk+PBa+vm38VVlhSE8wGkVKjhllDJVhH0AZ2FM8QpgKewgDWEBHIShkijCNkCAMBK8AgQJQ1gAJ2FMGmEbIEAY3AIECUNPnGcAJ2GUwC6AxylbCINjQF6EMPRMkI/sAibJAS3C5VpUKo84CTEL8MYbb8g/O38BZKGZ6+3aB6IAAAAASUVORK5CYII=" alt="zip--v1">
                          </div>

                          <div
                            class="br-10 bg-white p-2 mr-2"
                            v-else-if="documents.file_type == 'text/csv'"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="25px"
                              height="25px"
                              fill="currentColor"
                              class="bi bi-filetype-csv"
                              viewBox="0 0 16 16"
                            >
                              <path
                                fill-rule="evenodd"
                                d="M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM3.517 14.841a1.13 1.13 0 0 0 .401.823q.195.162.478.252.284.091.665.091.507 0 .859-.158.354-.158.539-.44.187-.284.187-.656 0-.336-.134-.56a1 1 0 0 0-.375-.357 2 2 0 0 0-.566-.21l-.621-.144a1 1 0 0 1-.404-.176.37.37 0 0 1-.144-.299q0-.234.185-.384.188-.152.512-.152.214 0 .37.068a.6.6 0 0 1 .246.181.56.56 0 0 1 .12.258h.75a1.1 1.1 0 0 0-.2-.566 1.2 1.2 0 0 0-.5-.41 1.8 1.8 0 0 0-.78-.152q-.439 0-.776.15-.337.149-.527.421-.19.273-.19.639 0 .302.122.524.124.223.352.367.228.143.539.213l.618.144q.31.073.463.193a.39.39 0 0 1 .152.326.5.5 0 0 1-.085.29.56.56 0 0 1-.255.193q-.167.07-.413.07-.175 0-.32-.04a.8.8 0 0 1-.248-.115.58.58 0 0 1-.255-.384zM.806 13.693q0-.373.102-.633a.87.87 0 0 1 .302-.399.8.8 0 0 1 .475-.137q.225 0 .398.097a.7.7 0 0 1 .272.26.85.85 0 0 1 .12.381h.765v-.072a1.33 1.33 0 0 0-.466-.964 1.4 1.4 0 0 0-.489-.272 1.8 1.8 0 0 0-.606-.097q-.534 0-.911.223-.375.222-.572.632-.195.41-.196.979v.498q0 .568.193.976.197.407.572.626.375.217.914.217.439 0 .785-.164t.55-.454a1.27 1.27 0 0 0 .226-.674v-.076h-.764a.8.8 0 0 1-.118.363.7.7 0 0 1-.272.25.9.9 0 0 1-.401.087.85.85 0 0 1-.478-.132.83.83 0 0 1-.299-.392 1.7 1.7 0 0 1-.102-.627zm8.239 2.238h-.953l-1.338-3.999h.917l.896 3.138h.038l.888-3.138h.879z"
                              />
                            </svg>
                          </div>

                          <div class="br-10 bg-white p-2 mr-2" v-else>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              fill="#9c8d0f"
                              class="bi bi-file-earmark-word"
                              viewBox="0 0 16 16"
                            >
                              <path
                                d="M5.485 6.879a.5.5 0 1 0-.97.242l1.5 6a.5.5 0 0 0 .967.01L8 9.402l1.018 3.73a.5.5 0 0 0 .967-.01l1.5-6a.5.5 0 0 0-.97-.242l-1.036 4.144-.997-3.655a.5.5 0 0 0-.964 0l-.997 3.655L5.485 6.88z"
                              />
                              <path
                                d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z"
                              />
                            </svg>
                          </div>

                          <div class="file-name-box">
                            <h5 class="fz-16 fw-600 mb-0">
                              {{
                                documents.file_name != "" && documents.file_name != null
                                  ? documents.file_name
                                  : documents.message
                              }}
                            </h5>
                            <span class="fz-12 text-muted">
                              {{ documents.size | sizeInMb }}</span
                            >
                          </div>
                        </div>
                      </a>
                      <div class="dropdown-option 4" v-if="documents.type == 3">
                        <div class="button-container">
                          <button
                            class="icon-button download-button"
                            aria-label="Download"
                            @click="
                              downloadFile(
                                documents.media_withoutbasepath,
                                documents.file_name != '' && documents.file_name != null
                                  ? documents.file_name
                                  : documents.message
                              )
                            "
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              class="bi bi-download"
                              viewBox="0 0 16 16"
                            >
                              <path
                                d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5"
                              />
                              <path
                                d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z"
                              />
                            </svg>
                          </button>
                          <button
                            class="icon-button delete-button"
                            aria-label="Delete"
                            v-if="
                              $store.state.currentUserData.login_master_id ==
                              documents.sended_by
                            "
                            v-b-modal.confirm-modal
                            @click="
                              deleteMsgSetVar(
                                documents.chat_id,
                                index,
                                ind,
                                mindex,
                                docIndex,
                                2
                              )
                            "
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              width="14"
                              height="14"
                            >
                              <path
                                d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm3-5h2v-2H9v2zm4 0h2v-2h-2v2zm5-9h-4.5L14 1H10l-1.5 3H5v2h14V5z"
                              />
                            </svg>
                          </button>
                        </div>
                      </div>
                     
                    </div>
                  </template>
                </div>
                <div class="recent-join-wrapper text-muteed text-center fz-14" v-else-if="[4,5,6].includes(messages.type)">
                  {{ messages.message }}
                </div>
              </div>
            </div>
          </div>
          <template v-if="localStorageMessageList.length > 0" >
            <div class="row message-body localStorageMessageList" >
              <div class="col-sm-12 mb-2" v-if="messagelist[messagelist.length - 1].key != localMessageStucture.key">
                <div class="unread-time-wrapper">
                  <div class="pos-rel time-wrap">
                    <span class="time pos-absolute">{{ localMessageStucture.key }}</span>
                  </div>
                </div>
              </div>

              <div class="content-holder mt-2" v-if="checklocalmessageArrayShowHide">
                <div class="d-flex align-items-center" v-if="nameImageShowForLocalMesage && localMessageStucture.value.key.type != 4 && localMessageStucture.value.key.type != 5 && localMessageStucture.value.key.type != 6">
                  <div class="img-holder w-10">
                    <div class="heading-avatar-icon">
                      <img :src="localMessageStucture.value.key.profile_picture_path" />
                      <span
                        class="status-icon"
                        :class="'status-' + localMessageStucture.value.key.sended_by"
                      ></span>
                    </div>
                  </div>
                  <div class="content-holder d-flex align-items-center">
                    <p class="mb-0 ml-2 fw-600">
                      {{ localMessageStucture.value.key.first_name }} {{ localMessageStucture.value.key.last_name }}
                    </p>
                    <span class="msg-time ml-2">{{
                      convertToLocalTime(localMessageStucture.value.key.time)
                    }}</span>
                  </div>
                </div>
                <div v-for="(messages, mindex) in localStorageMessageList"
                  :key="mindex"
                  :id="`local-${mindex}`"
                  :class="
                    messages.type == 3
                    ? 'pdf-div-css'
                    : messages.type == 2
                    ? 'chat-img-div-css'
                    : ''
                  "
                >
                  <div class="mb-2" style="padding-left: 47px;" v-if="messages.type == 1 && messages.is_sended != 2">
                    <div class="single-msg" id="single-msg">
                      <span v-if="messages.type == 1" class="msg-span"> 
                        <template v-if="messages.is_deleted == 0" >
                          <div style="display: flex;align-items: center;justify-content: flex-start;gap: 6px;">
                            <figure style="margin-bottom: 3px !important;">  
                              <svg xmlns="http://www.w3.org/2000/svg" width="15px" height="15px" viewBox="0 0 24 24" fill="none">
                                <path d="M12 17V12L14.5 10.5M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#00000045" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                            </figure>
                            <p
                            class="line-break-auto"
                            v-html="getHtmlContent(messages.message)"
                          ></p>
                          </div>
                          <!-- <span class="edited-msg-time" v-if="messages.is_updated == 1">Edited:{{convertToLocalTime(messages.updated_at)}}</span> -->
                        </template>
                        <div class="mb-3" v-else>
                          <span class="bg-grey p-2 br-10 text-muted"
                            ><i>{{
                              messages.sended_by ==
                              $store.state.currentUserData.login_master_id
                                ? "You deleted this message."
                                : "This message was deleted."
                            }}</i></span
                          >
                        </div>
                        <!-- <span class="msg-time ml-2">{{ messages.time }}</span> -->
                      </span>
                      <template  v-if="checkUserEditDeletePermission(messages) && messages.is_deleted == 0">
                        <div
                          class="dropdown-option 1"
                          v-if="
                            messages.is_deleted == 0 &&
                            messages.type == 1 &&
                            messages.sended_by == $store.state.currentUserData.login_master_id
                          "
                        >
                          <div class="button-container">
                           
                            <div class="edit-container" style="position: relative;">
                                <button
                                    class="icon-button edit-button"
                                    aria-label="Edit"
                                    @click="
                                      updateMessage.editMessage = true;
                                      sendChat.message = messages.message;
                                      updateMessage.chatIndex = index;
                                      updateMessage.chatData = messages;
                                      updateMessage.chatParentIndex = ind;
                                      updateMessage.chatChildIndex = mindex;
                                    "
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      viewBox="0 0 24 24"
                                      width="14"
                                      height="14"
                                    >
                                      <path
                                        d="M3 17.25v3.75h3.75L14.81 10.94l-3.75-3.75L3 17.25zM20.71 6.04a1 1 0 0 0 0-1.41l-3.29-3.29a1 1 0 0 0-1.41 0l-2.46 2.46 4.7 4.7 2.46-2.46a1 1 0 0 0 0-1.41z"
                                      />
                                    </svg>
                                  </button>
                                  <div class="no-internet-tooltip edit-ref">
                                    No internet connection
                                  </div>
                            </div>

                            
                            <button 
                              class="icon-button delete-button"
                              aria-label="Delete" 
                              @click="
                                deleteMsgSetVar(
                                  messages.chat_id,
                                  index,
                                  ind,
                                  mindex,
                                  $event,
                                  1
                                )
                              "
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                width="14"
                                height="14"
                              >
                                <path
                                  d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm3-5h2v-2H9v2zm4 0h2v-2h-2v2zm5-9h-4.5L14 1H10l-1.5 3H5v2h14V5z"
                                />
                              </svg>
                            </button>
                            
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>
                  <div class="inline-block mb-2 parent img-parent" v-else-if="messages.type == 2 && checklocalmediaHaveUnsend(messages.data)">
                    <div style="display: flex;flex-wrap: wrap;gap:10px">
                      <template v-for="(documents, docIndex) in messages.data">
                        <div
                          :key="docIndex"
                          v-if="documents.is_deleted == 0 && documents.is_sended != 2"
                          style="display:flex;align-items:flex-end;gap:5px" class="msg-span p-0"
                        >
                          <figure style="margin-bottom: 0px !important;">  
                            <svg xmlns="http://www.w3.org/2000/svg" width="15px" height="15px" viewBox="0 0 24 24" fill="none">
                              <path d="M12 17V12L14.5 10.5M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#00000045" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          </figure>
                          <div
                            class="msg-span file-span pos-rel chat-img-div-css" style="margin:0"
                            id="img-div"
                          >
                            <span>
                              <div class="retry-failed-no-internet-img">
                                <figure>
                                  <svg xmlns="http://www.w3.org/2000/svg" width="50px" height="50px" viewBox="0 -0.5 25 25" fill="none">
                                    <path d="M6.96967 16.4697C6.67678 16.7626 6.67678 17.2374 6.96967 17.5303C7.26256 17.8232 7.73744 17.8232 8.03033 17.5303L6.96967 16.4697ZM13.0303 12.5303C13.3232 12.2374 13.3232 11.7626 13.0303 11.4697C12.7374 11.1768 12.2626 11.1768 11.9697 11.4697L13.0303 12.5303ZM11.9697 11.4697C11.6768 11.7626 11.6768 12.2374 11.9697 12.5303C12.2626 12.8232 12.7374 12.8232 13.0303 12.5303L11.9697 11.4697ZM18.0303 7.53033C18.3232 7.23744 18.3232 6.76256 18.0303 6.46967C17.7374 6.17678 17.2626 6.17678 16.9697 6.46967L18.0303 7.53033ZM13.0303 11.4697C12.7374 11.1768 12.2626 11.1768 11.9697 11.4697C11.6768 11.7626 11.6768 12.2374 11.9697 12.5303L13.0303 11.4697ZM16.9697 17.5303C17.2626 17.8232 17.7374 17.8232 18.0303 17.5303C18.3232 17.2374 18.3232 16.7626 18.0303 16.4697L16.9697 17.5303ZM11.9697 12.5303C12.2626 12.8232 12.7374 12.8232 13.0303 12.5303C13.3232 12.2374 13.3232 11.7626 13.0303 11.4697L11.9697 12.5303ZM8.03033 6.46967C7.73744 6.17678 7.26256 6.17678 6.96967 6.46967C6.67678 6.76256 6.67678 7.23744 6.96967 7.53033L8.03033 6.46967ZM8.03033 17.5303L13.0303 12.5303L11.9697 11.4697L6.96967 16.4697L8.03033 17.5303ZM13.0303 12.5303L18.0303 7.53033L16.9697 6.46967L11.9697 11.4697L13.0303 12.5303ZM11.9697 12.5303L16.9697 17.5303L18.0303 16.4697L13.0303 11.4697L11.9697 12.5303ZM13.0303 11.4697L8.03033 6.46967L6.96967 7.53033L11.9697 12.5303L13.0303 11.4697Z" fill="#fff"/>
                                  </svg>
                                </figure>
                                  <span class="upload-tittle">Upload error</span>
                                  <span class="uplod-description">No internet connection!</span>
                                  <button>TRY AGAIN</button>
                              </div>
                              <img
                                class="no-internet-image-message"
                                v-lazy="documents.thumb"
                                width="100"
                                height="100"
                              />
                              <!-- <img
                                :src="documents.thumb"
                                @error="documents.thumb = documents.media"
                                width="100"
                                height="100"
                                @click="setSlider(messages.data), setImage(docIndex)"
                                v-b-modal.modal-image-slider
                              /> -->
                            </span>
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>
                  <div class="parent file-parent" v-else-if="messages.type == 3 && checklocalmediaHaveUnsend(messages.data)">
                    <div style="display: flex;flex-wrap: wrap;gap: 20px;padding-left: 50px;">
                      <template v-for="(documents, docIndex) in messages.data">
                        <div
                        :key="docIndex"
                        v-if="documents.is_deleted == 0 && documents.is_sended != 2"
                        style="display:flex;align-items:flex-end;gap:5px;margin-left:0"
                        class="pdf-div-css">
                          <figure style="margin-bottom: 0px !important;">  
                              <svg xmlns="http://www.w3.org/2000/svg" width="15px" height="15px" viewBox="0 0 24 24" fill="none">
                                <path d="M12 17V12L14.5 10.5M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#00000045" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                            </figure>
                        <div
                          class="msg-span file-span pos-rel "
                          :id="`file-div`"
                        >
                          <a href="javascript:void(0)" class="text-black d-block">
                            <div class="d-flex align-items-center">
                              
                              <div
                                class="br-10 bg-white p-2 mr-2"
                                v-if="
                                  documents.file_type == 'image/png' ||
                                  documents.file_type == 'image/jpeg'
                                "
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  fill="#c10000"
                                  class="bi bi-filetype-pdf"
                                  viewBox="0 0 16 16"
                                >
                                  <path
                                    fill-rule="evenodd"
                                    d="M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM1.6 11.85H0v3.999h.791v-1.342h.803q.43 0 .732-.173.305-.175.463-.474a1.4 1.4 0 0 0 .161-.677q0-.375-.158-.677a1.2 1.2 0 0 0-.46-.477q-.3-.18-.732-.179m.545 1.333a.8.8 0 0 1-.085.38.57.57 0 0 1-.238.241.8.8 0 0 1-.375.082H.788V12.48h.66q.327 0 .512.181.185.183.185.522m1.217-1.333v3.999h1.46q.602 0 .998-.237a1.45 1.45 0 0 0 .595-.689q.196-.45.196-1.084 0-.63-.196-1.075a1.43 1.43 0 0 0-.589-.68q-.396-.234-1.005-.234zm.791.645h.563q.371 0 .609.152a.9.9 0 0 1 .354.454q.118.302.118.753a2.3 2.3 0 0 1-.068.592 1.1 1.1 0 0 1-.196.422.8.8 0 0 1-.334.252 1.3 1.3 0 0 1-.483.082h-.563zm3.743 1.763v1.591h-.79V11.85h2.548v.653H7.896v1.117h1.606v.638z"
                                  />
                                </svg>
                              </div>

                              <div
                                class="br-10 bg-white p-2 mr-2"
                                v-else-if="documents.file_type == 'application/pdf'"
                              >
                              <svg fill="#C00001" height="40px" width="40px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 482.14 482.14" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <path d="M142.024,310.194c0-8.007-5.556-12.782-15.359-12.782c-4.003,0-6.714,0.395-8.132,0.773v25.69 c1.679,0.378,3.743,0.504,6.588,0.504C135.57,324.379,142.024,319.1,142.024,310.194z"></path> <path d="M202.709,297.681c-4.39,0-7.227,0.379-8.905,0.772v56.896c1.679,0.394,4.39,0.394,6.841,0.394 c17.809,0.126,29.424-9.677,29.424-30.449C230.195,307.231,219.611,297.681,202.709,297.681z"></path> <path d="M315.458,0H121.811c-28.29,0-51.315,23.041-51.315,51.315v189.754h-5.012c-11.418,0-20.678,9.251-20.678,20.679v125.404 c0,11.427,9.259,20.677,20.678,20.677h5.012v22.995c0,28.305,23.025,51.315,51.315,51.315h264.223 c28.272,0,51.3-23.011,51.3-51.315V121.449L315.458,0z M99.053,284.379c6.06-1.024,14.578-1.796,26.579-1.796 c12.128,0,20.772,2.315,26.58,6.965c5.548,4.382,9.292,11.615,9.292,20.127c0,8.51-2.837,15.745-7.999,20.646 c-6.714,6.32-16.643,9.157-28.258,9.157c-2.585,0-4.902-0.128-6.714-0.379v31.096H99.053V284.379z M386.034,450.713H121.811 c-10.954,0-19.874-8.92-19.874-19.889v-22.995h246.31c11.42,0,20.679-9.25,20.679-20.677V261.748 c0-11.428-9.259-20.679-20.679-20.679h-246.31V51.315c0-10.938,8.921-19.858,19.874-19.858l181.89-0.19v67.233 c0,19.638,15.934,35.587,35.587,35.587l65.862-0.189l0.741,296.925C405.891,441.793,396.987,450.713,386.034,450.713z M174.065,369.801v-85.422c7.225-1.15,16.642-1.796,26.58-1.796c16.516,0,27.226,2.963,35.618,9.282 c9.031,6.714,14.704,17.416,14.704,32.781c0,16.643-6.06,28.133-14.453,35.224c-9.157,7.612-23.096,11.222-40.125,11.222 C186.191,371.092,178.966,370.446,174.065,369.801z M314.892,319.226v15.996h-31.23v34.973h-19.74v-86.966h53.16v16.122h-33.42 v19.875H314.892z"></path> </g> </g></svg>
                              </div>

                              <div
                                class="br-10 bg-white p-2 mr-2"
                                v-else-if="
                                  documents.file_type ==
                                  'application\/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                                "
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  fill="#36d38a"
                                  class="bi bi-file-earmark-excel"
                                  viewBox="0 0 16 16"
                                >
                                  <path
                                    d="M5.884 6.68a.5.5 0 1 0-.768.64L7.349 10l-2.233 2.68a.5.5 0 0 0 .768.64L8 10.781l2.116 2.54a.5.5 0 0 0 .768-.641L8.651 10l2.233-2.68a.5.5 0 0 0-.768-.64L8 9.219l-2.116-2.54z"
                                  />
                                  <path
                                    d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z"
                                  />
                                </svg>
                              </div>

                              <div
                                class="br-10 bg-white p-2 mr-2"
                                v-else-if="documents.file_type == 'application/zip'"
                              >
                              <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACn0lEQVR4nO2VQWjTUByHX7aJ7iaKgjqxA6UIMp1D6KE7DivzoiBMFEYRQdSD7qAiwibVTURUxFFGd3GgggOPnoTtMJWhuK5r11rtDlaEMFDRoUNcfpLXLU2aNGmX995E8ofv0vTwfS//vhLijTfe/P+DHGlfyJFPygxB1eSMfBmQxoQHLMyQvBtpPfIVSXyE4kLYKkDla0x6tXIBVQgrH4wsBQiNUFwI2wXIoiLcCBt4bw6QRUS4ES7FKkBWIwY4RrgRrjRA5hnhRlgjW8AuQOYVsSzprDWzvZJzxCBh+z/hRriU+ZEViFBcSivvqiBThH1AloN0pjzsAgQJK0IDlrkWtqSNsA3gIZwxS6tgEXYBgoShZ5pngE7owe2tOHFsj4mfiVpcOrsT3ef9VPJpdJP27Ey4Cf0RH368rTNJ62EXYHOio4/WI3rdR+nu8iMYDOJ0uAl/UgQdh1sQPtpM5WI3ttFn/ZFG9Cx+r/fCDpO08IClNfidlHCqczdCbQF8HltDpa0C8qP1VK49FEBnR3P5gBSvgLQ193oaqeDzoQ3aSmgB0wSxvkLAs8GNGL6/Ga2tQfRd1L2BlBl2AQ4/vJdP1lGhm5e3G07RKkBlf1sAV7v8+P66zlKcS4DlTZEmkF+sputw/Mhe/IrXOAbkR+ptpaGSLMAswO6mOHdyFxU7dHCf4Raae1NbDEg5BCStYRdgc1M8vNOA6DVfgUiR+YkaDN1qwOO7W6jk+PBa+vm38VVlhSE8wGkVKjhllDJVhH0AZ2FM8QpgKewgDWEBHIShkijCNkCAMBK8AgQJQ1gAJ2FMGmEbIEAY3AIECUNPnGcAJ2GUwC6AxylbCINjQF6EMPRMkI/sAibJAS3C5VpUKo84CTEL8MYbb8g/O38BZKGZ6+3aB6IAAAAASUVORK5CYII=" alt="zip--v1">
                              </div>

                              <div
                                class="br-10 bg-white p-2 mr-2"
                                v-else-if="documents.file_type == 'text/csv'"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="25px"
                                  height="25px"
                                  fill="currentColor"
                                  class="bi bi-filetype-csv"
                                  viewBox="0 0 16 16"
                                >
                                  <path
                                    fill-rule="evenodd"
                                    d="M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM3.517 14.841a1.13 1.13 0 0 0 .401.823q.195.162.478.252.284.091.665.091.507 0 .859-.158.354-.158.539-.44.187-.284.187-.656 0-.336-.134-.56a1 1 0 0 0-.375-.357 2 2 0 0 0-.566-.21l-.621-.144a1 1 0 0 1-.404-.176.37.37 0 0 1-.144-.299q0-.234.185-.384.188-.152.512-.152.214 0 .37.068a.6.6 0 0 1 .246.181.56.56 0 0 1 .12.258h.75a1.1 1.1 0 0 0-.2-.566 1.2 1.2 0 0 0-.5-.41 1.8 1.8 0 0 0-.78-.152q-.439 0-.776.15-.337.149-.527.421-.19.273-.19.639 0 .302.122.524.124.223.352.367.228.143.539.213l.618.144q.31.073.463.193a.39.39 0 0 1 .152.326.5.5 0 0 1-.085.29.56.56 0 0 1-.255.193q-.167.07-.413.07-.175 0-.32-.04a.8.8 0 0 1-.248-.115.58.58 0 0 1-.255-.384zM.806 13.693q0-.373.102-.633a.87.87 0 0 1 .302-.399.8.8 0 0 1 .475-.137q.225 0 .398.097a.7.7 0 0 1 .272.26.85.85 0 0 1 .12.381h.765v-.072a1.33 1.33 0 0 0-.466-.964 1.4 1.4 0 0 0-.489-.272 1.8 1.8 0 0 0-.606-.097q-.534 0-.911.223-.375.222-.572.632-.195.41-.196.979v.498q0 .568.193.976.197.407.572.626.375.217.914.217.439 0 .785-.164t.55-.454a1.27 1.27 0 0 0 .226-.674v-.076h-.764a.8.8 0 0 1-.118.363.7.7 0 0 1-.272.25.9.9 0 0 1-.401.087.85.85 0 0 1-.478-.132.83.83 0 0 1-.299-.392 1.7 1.7 0 0 1-.102-.627zm8.239 2.238h-.953l-1.338-3.999h.917l.896 3.138h.038l.888-3.138h.879z"
                                  />
                                </svg>
                              </div>

                              <div class="br-10 bg-white p-2 mr-2" v-else>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  fill="#9c8d0f"
                                  class="bi bi-file-earmark-word"
                                  viewBox="0 0 16 16"
                                >
                                  <path
                                    d="M5.485 6.879a.5.5 0 1 0-.97.242l1.5 6a.5.5 0 0 0 .967.01L8 9.402l1.018 3.73a.5.5 0 0 0 .967-.01l1.5-6a.5.5 0 0 0-.97-.242l-1.036 4.144-.997-3.655a.5.5 0 0 0-.964 0l-.997 3.655L5.485 6.88z"
                                  />
                                  <path
                                    d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z"
                                  />
                                </svg>
                              </div>

                              <div class="file-name-box">
                                <h5 class="fz-16 fw-600 mb-0">
                                  {{
                                    documents.file_name != "" && documents.file_name != null
                                      ? documents.file_name
                                      : documents.message
                                  }}
                                </h5>
                                <span class="fz-12 text-muted">
                                  {{ documents.size | sizeInMb }}</span
                                >
                              </div>
                            </div>
                          </a>
                        </div>
                      </div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </span>
        <span class="no-data-conversation" v-else>
          <a href="javascript:void(0)">
            <div class="col-sm-12 col-xl-12 sideBar-avatar text-center">
              <div class="image-holder">
                <img src="/web/chat-box.png" alt="Chat" class="img-fluid" />
              </div>
              <h4 class="fz-16 fw-600 text-muted mb-0">Nothing here</h4>
              <p class="fz-12 fw-400 text-muted">
                There are no chats in your feed.
                <a href="javascript:void(0);" class="text-theme">Create a New Chat.</a>
              </p>
            </div>
          </a>
        </span>
      </div>
    </div>
    <div
      class="up-d-composer-attachment"
      v-if="preview_list.length > 0 && !chatLoader"
      style="z-index: 0;"
      :style="{ bottom: `${conversationHeight}px!important` }"
    >
      <h4 class="upload-message-flag">By uploading a file, you agree to Qapin security policy. In some cases we may alter your file for the security of our users. Visit our <a class="flag-link" href="#">Trust, Safety &amp; Security </a> page for more information.</h4>
      <div class="align-center">
        <template v-for="(prev, pindex) in preview_list">
          <div
            :key="pindex"
            v-if="pindex >= 0"
            class="up-d-file-attachment composer-attachment"
            :id="`remove-preview-file-${pindex}`"
          >
            <div
              :id="'progressbar_' + pindex"
              :aria-valuenow="prev.successStatus"
              aria-valuemin="0"
              aria-valuemax="100"
              :class="['file-attachment', { 
                'uploaded': prev.isuploaded === 1, 
                'error': prev.isuploaded === 0 ,
                'loading': prev.isuploaded === 2 

              }]"
            >
              <div style="display: flex;align-items: center;" :class="prev.fileType">
                <div class="attachment-preview"
                :class="
                  prev.type === 'application/pdf' ? 'pdf' :
                  prev.type === 'application/zip' || prev.type === 'application/x-rar-compressed' || prev.type === 'application/x-compressed' ? 'file-rar' :
                  prev.type === 'text/csv' ? 'csv' :
                  prev.type === 'excel' ? 'file-excel' :
                  'file-default'
                "
                >
                  <a
                    target="_blank"
                    class="up-d-story-img loaded"
                    style="    width: 40px;
                              height: 40px;
                              align-items: center;
                              justify-content: center;
                              display: flex
                          ; "
                  >
                    <img
                      :src="image_list[pindex]"
                      v-if="
                        prev.type == 'image/jpeg' ||
                        prev.type == 'image/jpg' ||
                        prev.type == 'image/png' ||
                        prev.type == 'image/svg' ||
                        prev.type == 'image/gif'
                      "
                    />

                    <div
                      class="br-10 bg-white p-2 mr-2"
                      v-else-if="prev.type == 'application/pdf'"
                    >
                    <svg fill="#C00001" height="40px" width="40px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 482.14 482.14" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <path d="M142.024,310.194c0-8.007-5.556-12.782-15.359-12.782c-4.003,0-6.714,0.395-8.132,0.773v25.69 c1.679,0.378,3.743,0.504,6.588,0.504C135.57,324.379,142.024,319.1,142.024,310.194z"></path> <path d="M202.709,297.681c-4.39,0-7.227,0.379-8.905,0.772v56.896c1.679,0.394,4.39,0.394,6.841,0.394 c17.809,0.126,29.424-9.677,29.424-30.449C230.195,307.231,219.611,297.681,202.709,297.681z"></path> <path d="M315.458,0H121.811c-28.29,0-51.315,23.041-51.315,51.315v189.754h-5.012c-11.418,0-20.678,9.251-20.678,20.679v125.404 c0,11.427,9.259,20.677,20.678,20.677h5.012v22.995c0,28.305,23.025,51.315,51.315,51.315h264.223 c28.272,0,51.3-23.011,51.3-51.315V121.449L315.458,0z M99.053,284.379c6.06-1.024,14.578-1.796,26.579-1.796 c12.128,0,20.772,2.315,26.58,6.965c5.548,4.382,9.292,11.615,9.292,20.127c0,8.51-2.837,15.745-7.999,20.646 c-6.714,6.32-16.643,9.157-28.258,9.157c-2.585,0-4.902-0.128-6.714-0.379v31.096H99.053V284.379z M386.034,450.713H121.811 c-10.954,0-19.874-8.92-19.874-19.889v-22.995h246.31c11.42,0,20.679-9.25,20.679-20.677V261.748 c0-11.428-9.259-20.679-20.679-20.679h-246.31V51.315c0-10.938,8.921-19.858,19.874-19.858l181.89-0.19v67.233 c0,19.638,15.934,35.587,35.587,35.587l65.862-0.189l0.741,296.925C405.891,441.793,396.987,450.713,386.034,450.713z M174.065,369.801v-85.422c7.225-1.15,16.642-1.796,26.58-1.796c16.516,0,27.226,2.963,35.618,9.282 c9.031,6.714,14.704,17.416,14.704,32.781c0,16.643-6.06,28.133-14.453,35.224c-9.157,7.612-23.096,11.222-40.125,11.222 C186.191,371.092,178.966,370.446,174.065,369.801z M314.892,319.226v15.996h-31.23v34.973h-19.74v-86.966h53.16v16.122h-33.42 v19.875H314.892z"></path> </g> </g></svg>
                    </div>
                    <div
                      class="br-10 bg-white p-2 mr-2"
                      v-else-if="prev.type == 'text/csv'"
                    >
                  <svg fill="#c10000" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 24 24" width="24px" height="24px">    <path d="M 6 2 C 4.895 2 4 2.895 4 4 L 4 9 L 3 9 C 1.895 9 1 9.895 1 11 L 1 16 C 1 17.105 1.895 18 3 18 L 4 18 L 4 20 C 4 21.105 4.895 22 6 22 L 13 22 L 13 20 L 6 20 L 6 18 L 14.107422 18 L 20 12.107422 L 20 7 L 15 2 L 6 2 z M 6 4 L 14 4 L 14 8 L 18 8 L 18 9 L 6 9 L 6 4 z M 3.0253906 11 L 4.2734375 11 L 4.9980469 12.716797 L 5.7246094 11 L 6.9707031 11 L 5.703125 13.478516 L 7 16 L 5.7382812 16 L 4.9980469 14.251953 L 4.2617188 16 L 3 16 L 4.2949219 13.478516 L 3.0253906 11 z M 8 11 L 9 11 L 9 15 L 11 15 L 11 16 L 8 16 L 8 11 z M 13.490234 11 C 14.913234 11.041 15 12.282906 15 12.503906 L 14.03125 12.503906 C 14.03125 12.400906 14.048656 11.806641 13.472656 11.806641 C 13.297656 11.806641 12.905547 11.884187 12.935547 12.367188 C 12.964547 12.810188 13.547297 13.019406 13.654297 13.066406 C 13.878297 13.148406 14.987094 13.642391 14.996094 14.650391 C 14.998094 14.864391 14.942766 15.985 13.509766 16 C 11.950766 16.017 11.845703 14.675437 11.845703 14.398438 L 12.820312 14.398438 C 12.820312 14.545438 12.832766 15.256172 13.509766 15.201172 C 13.916766 15.167172 14.005531 14.87425 14.019531 14.65625 C 14.042531 14.28925 13.692266 14.068625 13.322266 13.890625 C 12.802266 13.640625 11.979844 13.333375 11.964844 12.359375 C 11.951844 11.482375 12.596234 10.975 13.490234 11 z M 19 16 L 15 20 L 18 20 L 18 24 L 20 24 L 20 20 L 23 20 L 19 16 z"/></svg>
                    </div>

                    <div
                      class="br-10 bg-white p-2 mr-2"
                      v-else-if="
                        prev.type ==
                        'application\/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                      "
                    >
                      <svg xmlns="http://www.w3.org/2000/svg"  width="25" height="25" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" viewBox="0 0 303.188 303.188" xml:space="preserve"><g><polygon style="fill:#E4E4E4;" points="219.821,0 32.842,0 32.842,303.188 270.346,303.188 270.346,50.525  "/><polygon style="fill:#007934;" points="227.64,25.263 32.842,25.263 32.842,0 219.821,0  "/><g><g><path style="fill:#A4A9AD;" d="M114.872,227.984c-2.982,0-5.311,1.223-6.982,3.666c-1.671,2.444-2.507,5.814-2.507,10.109     c0,8.929,3.396,13.393,10.188,13.393c2.052,0,4.041-0.285,5.967-0.856c1.925-0.571,3.86-1.259,5.808-2.063v10.601     c-3.872,1.713-8.252,2.57-13.14,2.57c-7.004,0-12.373-2.031-16.107-6.094c-3.734-4.062-5.602-9.934-5.602-17.615     c0-4.803,0.904-9.023,2.714-12.663c1.809-3.64,4.411-6.438,7.808-8.395c3.396-1.957,7.39-2.937,11.98-2.937     c5.016,0,9.808,1.09,14.378,3.27l-3.841,9.871c-1.713-0.805-3.428-1.481-5.141-2.031     C118.681,228.26,116.841,227.984,114.872,227.984z"/><path style="fill:#A4A9AD;" d="M166.732,250.678c0,2.878-0.729,5.433-2.191,7.665c-1.459,2.232-3.565,3.967-6.315,5.205     c-2.751,1.237-5.977,1.856-9.681,1.856c-3.089,0-5.681-0.217-7.775-0.65c-2.095-0.434-4.274-1.191-6.538-2.27v-11.172     c2.391,1.227,4.877,2.186,7.458,2.872c2.582,0.689,4.951,1.032,7.109,1.032c1.862,0,3.227-0.322,4.095-0.969     c0.867-0.645,1.302-1.476,1.302-2.491c0-0.635-0.175-1.19-0.524-1.666c-0.349-0.477-0.91-0.958-1.682-1.444     c-0.772-0.486-2.83-1.48-6.173-2.983c-3.026-1.375-5.296-2.708-6.809-3.999s-2.634-2.771-3.364-4.443s-1.095-3.65-1.095-5.936     c0-4.273,1.555-7.605,4.666-9.997c3.109-2.391,7.384-3.587,12.822-3.587c4.803,0,9.7,1.111,14.694,3.333l-3.841,9.681     c-4.337-1.989-8.082-2.984-11.234-2.984c-1.63,0-2.814,0.286-3.555,0.857s-1.111,1.28-1.111,2.127     c0,0.91,0.471,1.725,1.412,2.443c0.941,0.72,3.496,2.031,7.665,3.936c3.999,1.799,6.776,3.729,8.331,5.792     C165.955,244.949,166.732,247.547,166.732,250.678z"/><path style="fill:#A4A9AD;" d="M199.964,218.368h14.027l-15.202,46.401H184.03l-15.139-46.401h14.092l6.316,23.519     c1.312,5.227,2.031,8.865,2.158,10.918c0.148-1.481,0.443-3.333,0.889-5.555c0.443-2.222,0.835-3.967,1.174-5.236     L199.964,218.368z"/></g></g><polygon style="fill:#D1D3D3;" points="219.821,50.525 270.346,50.525 219.821,0  "/><g><rect x="134.957" y="80.344" style="fill:#007934;" width="33.274" height="15.418"/><rect x="175.602" y="80.344" style="fill:#007934;" width="33.273" height="15.418"/><rect x="134.957" y="102.661" style="fill:#007934;" width="33.274" height="15.419"/><rect x="175.602" y="102.661" style="fill:#007934;" width="33.273" height="15.419"/><rect x="134.957" y="124.979" style="fill:#007934;" width="33.274" height="15.418"/><rect x="175.602" y="124.979" style="fill:#007934;" width="33.273" height="15.418"/><rect x="94.312" y="124.979" style="fill:#007934;" width="33.273" height="15.418"/><rect x="134.957" y="147.298" style="fill:#007934;" width="33.274" height="15.418"/><rect x="175.602" y="147.298" style="fill:#007934;" width="33.273" height="15.418"/><rect x="94.312" y="147.298" style="fill:#007934;" width="33.273" height="15.418"/><g><path style="fill:#007934;" d="M127.088,116.162h-10.04l-6.262-10.041l-6.196,10.041h-9.821l10.656-16.435L95.406,84.04h9.624     l5.8,9.932l5.581-9.932h9.909l-10.173,16.369L127.088,116.162z"/></g></g></g></svg>
                    </div>

                    <div 
                    v-else-if="
                        prev.type == 'application/zip' ||
                        prev.type == 'application/x-rar-compressed'||
                        prev.type == 'application/x-compressed'
                      ">
                      <svg fill="#c10000" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 24 24" width="27px" height="27px"><path d="M 6 2 C 4.9057453 2 4 2.9057453 4 4 L 4 9 C 2.895 9 2 9.895 2 11 L 2 16 C 2 17.105 2.895 18 4 18 L 4 20 C 4 21.094255 4.9057453 22 6 22 L 18 22 C 19.094255 22 20 21.094255 20 20 L 20 7 L 15 2 L 6 2 z M 6 4 L 14 4 L 14 8 L 18 8 L 18 20 L 6 20 L 6 18 L 13 18 C 14.105 18 15 17.105 15 16 L 15 11 C 15 9.895 14.105 9 13 9 L 6 9 L 6 4 z M 4 11 L 7 11 L 7 12 L 5.3242188 15 L 7 15 L 7 16 L 4 16 L 4 15 L 5.7050781 12 L 4 12 L 4 11 z M 7.9941406 11 L 9 11 L 9 16 L 7.9941406 16 L 7.9941406 11 z M 10 11 L 11 11 L 11.5 11 C 12.328 11 13 11.672 13 12.5 C 13 13.328 12.328 14 11.5 14 L 11 14 L 11 16 L 10 16 L 10 14 L 10 11 z M 11 12 L 11 13 L 11.5 13 C 11.776 13 12 12.776 12 12.5 C 12 12.224 11.776 12 11.5 12 L 11 12 z"/></svg>
                    </div>

                    <div class="br-10 bg-white p-2 mr-2" v-else>
                      <svg fill="#c10000" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 24 24" width="24px" height="24px"><path d="M 6 2 C 4.9057453 2 4 2.9057453 4 4 L 4 9 C 2.895 9 2 9.895 2 11 L 2 16 C 2 17.105 2.895 18 4 18 L 4 20 C 4 21.094255 4.9057453 22 6 22 L 18 22 C 19.094255 22 20 21.094255 20 20 L 20 7 L 15 2 L 6 2 z M 6 4 L 14 4 L 14 8 L 18 8 L 18 20 L 6 20 L 6 18 L 13 18 C 14.105 18 15 17.105 15 16 L 15 11 C 15 9.895 14.105 9 13 9 L 6 9 L 6 4 z M 4 11 L 7 11 L 7 12 L 5.3242188 15 L 7 15 L 7 16 L 4 16 L 4 15 L 5.7050781 12 L 4 12 L 4 11 z M 7.9941406 11 L 9 11 L 9 16 L 7.9941406 16 L 7.9941406 11 z M 10 11 L 11 11 L 11.5 11 C 12.328 11 13 11.672 13 12.5 C 13 13.328 12.328 14 11.5 14 L 11 14 L 11 16 L 10 16 L 10 14 L 10 11 z M 11 12 L 11 13 L 11.5 13 C 11.776 13 12 12.776 12 12.5 C 12 12.224 11.776 12 11.5 12 L 11 12 z"/></svg>
                    </div>
                  </a>
                </div>
                <div class="file-name-wrapper">
                  <span class="file-name">
                    <span class="name">
                      {{ prev.name }}
                    </span>
                  </span>
                  <div class="file-content ">
                    <span

                      :style="{
                        fontSize: '12px',
                        fontWeight: '700',
                        color: '#00000075',
                      }"
                      class="total-file-size text-size d-flex align-items-center"
                    >
                      {{ prev.size | sizeInMb }}
                      <!-- <span
                        class="file-check-icon"
                        :id="'progress-complete_' + pindex"
                        style="display: none"
                      ></span> -->
                    </span>
                    <span class="upload-err-msg" :style="{
                      color:'red !important',
                      fontWeight:600,
                      fontSize: '14px',
                    }" :id="'uploaded-err_' + pindex">The file type is not acceptable</span>

                    <div
                class="upload-status"
                :style="{
                  margin: '0 0 0',
                  fontSize: '12px',
                  color: '#00000065',
                }"
                :id="'uploading-status-container_' + pindex"
              >
                <span
                  :style="{
                    width: '14px',
                    height: '14px',
                    border: '2px solid #000',
                    borderBottomColor: 'transparent',
                    borderRadius: '50%',
                    display: 'inline-block',
                    boxSizing: 'border-box',
                    animation: 'rotation 1s linear infinite',
                    verticalAlign: 'sub',
                    marginRight: '5px',
                  }"
                  class="upload-status-loader"
                ></span>
                Uploading... <span :id="'uploaded-size_' + pindex"></span> /
                {{ prev.size | sizeInMb }}

              </div>
                  </div>
                </div>
                <span class="remove-attachment" @click="removePrev(pindex)">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                    viewBox="0 0 14 14"
                    role="img"
                    class="remove-icon"
                  >
                    <polygon
                      fill-rule="evenodd"
                      points="12.524 0 7 5.524 1.476 0 0 1.476 5.524 7 0 12.524 1.476 14 7 8.476 12.524 14 14 12.524 8.476 7 14 1.476"
                    ></polygon>
                  </svg>
                </span>
              </div>
            </div>
          </div>
        </template>
      </div>
     
    </div>


    <div
      class="chat-input"
      :class="parentClass"
      v-if="getmessageparams.chat_room_id != '' && !chatLoader"
    >
      <div class="row reply d-flex align-items-center m-0">
        <div class="typing-title" id="typingtitle" v-if="typingUsersText != ''" >
          <h6 class="mb-0 fz-14 text-muted">{{ typingUsersText }}</h6>
        </div>
        <!-- <div class="row reply d-flex align-items-center m-0" v-if="messagelist.length > 0 || pageType=='sidebar' || pageType=='contractpage' "> -->
        <b-col xl="12" lg="12" sm="12" class="pt-0">
          <form @submit.prevent="submitform" class="p-0 h-70px">
            <b-row class="d-flex align-items-center">
              <b-col
                xl="1"
                sm="12"
                style="position:relative"
                class="d-flex align-items-center justify-content-center p-0 l-sec"
                :class="{ 'no-internet-tooltip-wr': !isOnline }"
              >
                <input
                  id="fileUpload"
                  style="display: none"
                  multiple
                  hidden
                  type="file"
                  @change="UploadFile"
                  accept=".png,.PNG,.jpeg,.JPEG,.jpg,.JPG,.word,.pdf,.xlsx,.xls,.csv,.zip,.rar,
                                            application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,
                                            text/csv,application/zip,application/x-zip-compressed,application/x-rar-compressed,application/vnd.rar"
                />

                <div class="no-internet-tooltip">
                  No internet connection
                </div>

                <div
                  class="reply-recording text-right "
                  :class="{ 'no-internet': !isOnline }"
                  v-if="updateMessage.editMessage == false && getmessageparams.chat_room_id != ''"
                  @click="chooseFiles()"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-paperclip"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M4.5 3a2.5 2.5 0 0 1 5 0v9a1.5 1.5 0 0 1-3 0V5a.5.5 0 0 1 1 0v7a.5.5 0 0 0 1 0V3a1.5 1.5 0 1 0-3 0v9a2.5 2.5 0 0 0 5 0V5a.5.5 0 0 1 1 0v7a3.5 3.5 0 1 1-7 0V3z"
                    />
                  </svg>
                </div>
                <div
                  class="reply-recording text-right"
                  v-if="updateMessage.editMessage == true"
                  @click="cancelEdit()"
                >
                  <i class="fa fa-close"></i>
                </div>
              </b-col>
              <b-col xl="11" sm="12" class="r-sec" style="padding-top:0px;padding-bottom:0px">
                <div class="reply-emojis w-100 pos-rel">
                  <div class="in-wrap">
                    <b-row>
                      <b-col xl="1">
                        <emoji-picker
                          v-if="getmessageparams.chat_room_id != ''"
                          @emoji="append"
                          :search="searchEmoji"
                        >
                          <button
                            type="button"
                            class="emoji-invoker"
                            slot="emoji-invoker"
                            slot-scope="{ events: { click: clickEvent } }"
                            @click.stop="clickEvent"
                          >
                            <svg
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              class="h-6 w-6 fill-current text-grey"
                            >
                              <path d="M0 0h24v24H0z" fill="none" />
                              <path
                                d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
                              />
                            </svg>
                          </button>

                          <div
                            slot="emoji-picker"
                            slot-scope="{ emojis, append, display }"
                          >
                            <div
                              class="emoji-picker"
                              :style="{ top: display.y + 'px', left: display.x + 'px' }"
                            >
                              <div class="emoji-picker__search">
                                <input
                                  type="text"
                                  v-model="searchEmoji"
                                  placeholder="Search"
                                />
                              </div>
                              <div>
                                <div
                                  v-for="(emojiGroup, category) in emojis"
                                  :key="category"
                                >
                                  <h5>{{ category }}</h5>
                                  <div class="emojis">
                                    <span
                                      v-for="(emoji, emojiName) in emojiGroup"
                                      :key="emojiName"
                                      @click="insert(emoji)"
                                      :title="emojiName"
                                      >{{ emoji }}</span
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </emoji-picker>
                      </b-col>

                      <!-- <div v-if="getmessageparams.chat_room_id!=''" class="settings-btn-wrap">
                                                <b-dropdown id="dropdown-dropup" dropup right class="setting-btn enter-btn-setting">
                                                    <template #button-content>
                                                        <i class="fa fa-cog text-black" aria-hidden="true"></i>
                                                    </template>
                                                    <b-dropdown-item><b>Pressing Enter Key Will :</b></b-dropdown-item>
                                                    <b-dropdown-item @click="UpdateEnterBtnRole('A')">
                                                        <div class="custom-control custom-control-inline custom-radio">
                                                            <input type="radio" class="custom-control-input" value="A" id="__BVID__62_BV_option_1" name="__BVID__62" v-model="SetEnterBtnRole">
                                                            <label class="custom-control-label" for="__BVID__62_BV_option_1"><span>Send Message</span></label>
                                                        </div>

                                                    </b-dropdown-item>
                                                    <b-dropdown-item @click="UpdateEnterBtnRole('B')">
                                                        <div class="custom-control custom-control-inline custom-radio">
                                                            <input type="radio" class="custom-control-input" value="B" id="__BVID__62_BV_option_2" name="__BVID__62" v-model="SetEnterBtnRole">
                                                            <label class="custom-control-label" for="__BVID__62_BV_option_2"><span>Add a link break</span></label>
                                                        </div>
                                                    </b-dropdown-item>
                                                    <b-dropdown-item>You can always use Shift+Enter to type multi-line messages.</b-dropdown-item>
                                                </b-dropdown>
                                            </div> -->
                      <!-- <textarea class="form-control" v-if="getmessageparams.chat_room_id!=''" v-model="sendChat.message" @keydown="handleEnterKeyEvent($event);sendChat.messageType = 1;" rows="1" id="comment" ></textarea> -->
                      <!-- <editor
                                                ref="editor"
                                                :editor="editor"
                                                class="tiptap-editor"
                                            /> -->
                      <!-- <wysiwyg class="form-control" v-if="getmessageparams.chat_room_id!=''" @change="handleTyping(chatroomdata.chat_room_id, $store.state.currentUserData.login_master_id,$store.state.accountType)" v-model="sendChat.message" @keyup.enter="sendChat.messageType = 1;"/> -->
                      <b-col xl="10">
                        <tiptap-editor
                        ref="editor"
                          v-if="getmessageparams.chat_room_id != ''"
                          v-model="sendChat.message"
                          :placeholder="
                            !canSendMessage(sendChat.message, 'button')
                              ? 'Send a message...'
                              : 'Send a message...'
                          "
                          :mentions="chatroomMembers"
                          @change="
                            handleTyping(
                              chatroomdata.chat_room_id,
                              $store.state.currentUserData.login_master_id,
                              $store.state.accountType
                            )
                          "
                          @uploaderHight="(data) => (tipTopHeight = data)"
                          @typingtitleHight="(data) => (typingtitleHight = data)"
                          @conversation="(data) => (conversationHeight = data)"
                        />
                      </b-col>
                      <b-col xl="1">
                        <div
                          v-if="getmessageparams.chat_room_id != ''"
                          class="reply-send"
                          :class="{
                            'bg-theme':
                              (totalfilesuploading > 0 &&
                                filesuploadcount == totalfilesuploading) ||
                              (!canSendMessage(sendChat.message, 'button') &&
                                filesuploadcount == totalfilesuploading),
                            '':
                              canSendMessage(sendChat.message, 'button') &&
                              filesuploadcount != totalfilesuploading,
                          }"
                        >
                          <!-- :disabled="((totalfilesuploading > 0 && filesuploadcount == totalfilesuploading))|| ((!canSendMessage(sendChat.message,'button')) && (filesuploadcount == totalfilesuploading))" -->
                          <b-button
                            type="submit"
                            :disabled="
                              (totalfilesuploading <= 0 ||
                                filesuploadcount != totalfilesuploading) &&
                              (canSendMessage(sendChat.message, 'button') ||
                                filesuploadcount != totalfilesuploading)
                            "
                            style="
                              padding: 0px 0px;
                              position: relative;
                              left: 0;
                              right: 0;
                              top: 0px !important;
                              bottom: 0;
                            "
                            class="btn chat-reply-btn"
                          >
                            <!-- <b-button type="submit" :disabled="(!sendChat.message || (/^\s*$/.test(sendChat.message)) || !canSendMessage(sendChat.message,'button')) && sendChat.mediaData.length == 0" style="padding: 0px 0px;position: relative;left: 0;right: 0;top: 0px!important;bottom: 0;" class="btn chat-reply-btn"> -->
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              fill="currentColor"
                              class="bi bi-send"
                              viewBox="0 0 16 16"
                            >
                              <path
                                d="M15.854.146a.5.5 0 0 1 .11.54l-5.819 14.547a.75.75 0 0 1-1.329.124l-3.178-4.995L.643 7.184a.75.75 0 0 1 .124-1.33L15.314.037a.5.5 0 0 1 .54.11ZM6.636 10.07l2.761 4.338L14.13 2.576zm6.787-8.201L1.591 6.602l4.339 2.76z"
                              />
                            </svg>
                          </b-button>
                        </div>
                      </b-col>
                    </b-row>
                  </div>
                </div>
              </b-col>
            </b-row>
          </form>
        </b-col>
      </div>
    </div>
    <!-- this modal is for to image preview -->
    <b-modal id="modal-image-slider" size="xl" title="" centered hide-header hide-footer>
      <b-carousel
        :interval="0"
        class="mb-3"
        id="carousel-1"
        v-model="slider"
        controls
        indicators
        background="#ababab"
        style="text-shadow: 1px 1px 2px #333; width: 100%; height: 100%"
        @sliding-start="onSlideStart"
        @sliding-end="onSlideEnd"
      >
        <!-- Slides with image only -->
        <b-carousel-slide
          v-for="(data, index) in sliderImages"
          :key="index"
          :img-src="data.media"
        >
        </b-carousel-slide>
        <!-- Slides with img slot -->
      </b-carousel>
      <div class="text-right">
        <b-button
          class="cancel-btn btn-outline-theme mr-2"
          @click="$bvModal.hide('modal-image-slider')"
          >Cancel</b-button
        >
        <b-button class="download-btn btn-theme" @click="downloadAllfiles(sliderImages)"
          >Download</b-button
        >
      </div>
    </b-modal>

    <!-- Delete Confirmation Modal -->
    <Confirm-Message
      ref="callparentFunction"
      :title="modelTitle"
      :headTitle="MessageRemove"
      @accept="deleteMsg()"
      @reject="rejectRequest()"
    ></Confirm-Message>

    <div v-if="isDragging" class="drop-overlay">
      <div class="drop-file-container">
        <figure>
          <img src="../../assets/img/open-folder-icon.png" />
          <figcaption>
            Drag & Drop files here <br />
            to share
          </figcaption>
          <!-- <span>1GB max</span> -->
        </figure>
      </div>
    </div>
  </span>
</template>
<script>
var that = "";
import $ from "jquery";
import { mapActions, mapGetters } from "vuex";
import LazyLoad from "../../directives/lazyLoad";
import TiptapEditor from "../editor/TiptapEditor.vue";
import moment from "moment";
//import { debounce } from 'lodash';
export default {
  directives: {
     lazy: LazyLoad, // Register directive locally
   },
  created() {
    that = this;
    window.addEventListener("keydown", function (event) {
      // console.log("event11111111", event.key);
      // console.log(that.$store.state.enterBtnRole);
      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent); 
      if (
        that.$store.state.enterBtnRole == "A" ||
        that.$store.state.enterBtnRole == "B"
      ) {
        // console.log("event", event);
        if (event.key === "Enter") {
            if (isMobile) {
                // Prevent Enter from submitting on mobile (allow new line)
               // event.preventDefault();
                // const textarea = document.activeElement;
                // if (textarea && textarea.tagName === "TEXTAREA") {
                //     textarea.value += "\n"; // Add a new line
                // }
                //that.sendChat.message = "\n";

            } else if (!event.shiftKey) {
            event.preventDefault();
                var messageStatus = that.sendChat.message
                    .replaceAll("&nbsp;", "")
                    .replaceAll(" ", "")
                    .replaceAll("<div><br></div>", "")
                    .trim();
                if (messageStatus != "") {
                    that.submitform();
                } else {
                    that.sendChat.message = "";
                }
            }
        }
      }
    });
  },
  props: {
    // Simple props
    chatroomdata: {
      type: Object,
      required: true,
    },
    pageType: {
      type: String,
      required: true,
    },
    roomlist: {
      type: Array,
      required: true,
    },
    chatroomMembers: {
      type: Array,
      required: true,
    },
    // The dynamic class prop
    parentClass: {
      type: String,
      default: "", // Default to an empty string if not passed
    },
  },
  data() {
    return {
      editor: null,
      modelTitle: "Are you sure you want to delete this message?",
      MessageRemove: "Delete Message",
      tipTopHeight: 0,
      conversationHeight:0,
      count: 5,
      search: "",
      searchEmoji: "",
      messagelist: [],
      getmessageparams: {
        chat_room_id: "",
        start_limit: 0,
        end_limit: 20,
        cycle: "",
        lastId: "",
        firstId: "",
      },
      sendChat: {
        message: "",
        messageType: "",
        mediaData: [],
      },
      currentUser: "",
      updateMessage: {
        chatData: "",
        chatIndex: "",
        chatParentIndex: "",
        chatChildIndex: "",
        editMessage: false,
      },
      emoji: [],
      append: "",
      preview_list: [],
      image_list: [],
      uploadRecentfiles: {
        chat_room_id: "",
        message: "",
        file_path: "",
        files: [],
      },
      sliderImages: "",
      slide: 0,
      sliding: null,
      slider: 0,
      sendMsgStatus: 0,
      chatLoader: true,
      getmessageCycleNew: null,
      chatdataResponse: "",
      typingTimeout: "",
      typingUsers: {}, // Track typing users in the current chat room
      deleteParam: {
        chatData: "",
        chatIndex: "",
        chatParentIndex: "",
        chatChildIndex: "",
        chatEvent: "",
        chatType: "",
      },
      filesuploadcount: 0,
      totalfilesuploading: 0,
      isDragging:false,
      uploadedSizeMB: 0,
      rawDate: new Date(),
      totalMessageCount : 0,
      localMessageCount : 0,
      localMessageStucture: {
        "key": "Today",
        "value": {
          "key" : {
              "first_name": '',
              "last_name": '',
              "profile_picture_path": '',
              "sended_by": '',
              "time": moment(this.rawDate).toISOString(),
              "created_at": moment(this.rawDate).toISOString(),
              "type": 0
          },
          "value": []
        }
      },
      localStorageMessageList:[],
      messageUpCycleData: {
        status : true,
        localId : 0,
      },
      defaultImage: '/web/upload-err.png', 
    };
  },
  mounted() {
    // In any JavaScript file, for example, in a Vue component
    window.scrollTo(0, 0);
    that = this;
    that.onloadConnection();
    console.log('localMessageStucture',that.permissionUserData(),that.localMessageStucture,this.formattedDate)
  },
  methods: {
    ...mapActions([
      "genericAPIPOSTRequest",
      "cancelApiRequest",
      "UpdateEnterBtnRole",
      "genericAPIPOSTForNodeRequest",
      "genericAPIPOSTForNodeFormData",
      "genericAPIPOSTForNodeFormDataWithProgress",
    ]),
    ...mapActions("global", [
      "UpdateChatLoaderStatus",
      "fetchChatfromSocket",
      "UpdateMessageRequestData",
      "EmptyMessageData",
      "UpdateChatRoomResponse",
      "UpdateMessageCycleData",
    ]),
    reconnectSocket() {
      console.log("Attempting WebSocket reconnection...");
      // You can call your initialization function here or recreate the socket connection
      this.$socket.connect(); // This will attempt to reconnect
    },
    // this fun is for to check local message data have any unsend media
    checklocalmediaHaveUnsend(chatData){
      const hasUnsentMessages = chatData.some(msg => msg.is_sended !== 2);
      // console.log('checklocalmediaHaveUnsend',hasUnsentMessages)
      return hasUnsentMessages;
    },
    // this fun is for to check user can edit or delete message
    checkUserEditDeletePermission(chatData){
      // console.log('chatData',chatData);
      if(chatData.sended_by === this.$store.state?.currentUserData?.login_master_id  && this.$store.state?.currentUserData?.permission==null && chatData.chat_invitation_id==0  ){
        return true;
      }else if(this.$store.state?.currentUserData?.permission!=null && chatData.sended_by === this.$store.state?.currentUserData?.permission?.user_id &&  chatData.chat_invitation_id > 0 ){
        return true;
      }
      return false;
    },
    canSendMessage(_v, _t = null) {
      _t
      // Remove empty paragraph tags, line breaks, and whitespace
      const strippedContent = _v
        .replace(/<p[^>]*>\s*<\/p>/g, "") // Remove <p> tags with only spaces
        .replace(/<br\s*\/?>/g, "") // Remove <br> tags
        .replace(/&nbsp;/g, "") // Remove non-breaking spaces
        .replace(/\s+/g, ""); // Remove all other whitespace
          
        let text = strippedContent.replace(/<br\s*\/?>/gi, '').replace(/<\/?p[^>]*>/gi, '').trim();
        var res = text === ""; // Return true if nothing is left
        // console.log("canSendMessage", res, _t);
        return res;
    },
    // canSendMessage: debounce(function (_v, _t = null) {
    //     const strippedContent = _v
    //         .replace(/<p[^>]*>\s*<\/p>/g, '')
    //         .replace(/<br\s*\/?>/g, '')
    //         .replace(/&nbsp;/g, '')
    //         .replace(/\s+/g, '');

    //     var res = strippedContent === '';
    //     console.log('canSendMessage', res, _t);
    //     return res;
    // }, 300), // Delay execution by 300ms
    onDragOver(event) {
      event.preventDefault(); // Necessary for allowing drops
      // if (event.target.classList.contains('message')) {
      this.isDragging = true;
      console.log("Dragging over the correct area");
      //}
    },
    onDragLeave(event) {
      event.preventDefault();
      event.stopPropagation(); // Prevents bubbling up
      this.isDragging = false;
    },
    onDrop(event) {
      this.isDragging = false;
      const files = event.dataTransfer.files;
      if (files.length > 0) {
        this.UploadFile({ target: { files } });
      }
    },
    // this fun is for to get handle typing indicatore
    handleTyping(chat_room_id, user_id, _type) {
      console.log("handleTyping", chat_room_id, user_id, _type);
      // Notify server that the user is typing
      this.$socket.emit("typing", { chat_room_id, user_id, _type });
      // Clear the previous timeout
      clearTimeout(this.typingTimeout);
      // Set a timeout to emit "stopTyping" after 3 seconds of inactivity
      this.typingTimeout = setTimeout(() => {
        // this.$socket.emit("stopTyping", { chat_room_id, user_id, _type });
      }, 3000);
    },
    // this fun is for to download multiple files
    downloadAllfiles(_v) {
      for (const data of _v) {
        setTimeout(() => {
          return that.downloadFile(
            data.media_withoutbasepath,
            data.file_name != "" && data.file_name != null ? data.file_name : data.message
          );
        }, 2000);
      }
    },
    // this fun is for to hanle scroll
    async handleScroll(event) {
      // const currentScrollPosition = event.target.scrollTop;
      // if (currentScrollPosition <= 10 && that.messageUpCycleData.status) {
      //   console.log('aliakbar')
      //   // that.UpdateMessageCycleData('');
      //   var messageRequestdata = that.$store.state.global.mRequestData;
      //   messageRequestdata.cycle = "up";
      //   messageRequestdata.localId = Math.ceil(Math.random()*1000);
      //   that.messageUpCycleData = {
      //     status: false,
      //     localId : messageRequestdata.localId,
      //   }
      //   // var element = document.getElementById("conversation");
      //   // element.classList.add("stop-scrolling");
      //   // window.addEventListener('DOMMouseScroll',event.preventDefault, false); // older FF
      //   await that.UpdateMessageRequestData({ params: messageRequestdata });
      //   // Emit the request to join the room and fetch messages
      //   that.$socket.emit("getMessageofRoom", {
      //     request: messageRequestdata
      //   });
      //   console.log('messageRequestdata',messageRequestdata)
      // }
      const currentScrollPosition = event.target.scrollTop;
      console.log('currentScrollPosition',currentScrollPosition);
      // Trigger when scrolling up, and only if the cycle status is true
      console.log('that.totalMessageCount.length',that.totalMessageCount)
      if (currentScrollPosition <= 20 && that.messageUpCycleData.status && that.totalMessageCount > 0) {
        console.log('Fetching previous messages...');
      //alert('asasasas');
        // Save the current scroll position before adding new messages
        const scrollPositionBeforeFetch = event.target.scrollTop;
        
        // Save the current scroll height before the new messages are added
        const scrollHeightBeforeFetch = event.target.scrollHeight;

        // Prepare the request data
        var messageRequestdata = that.$store.state.global.mRequestData;
        messageRequestdata.cycle = "up";
        messageRequestdata.localId = Math.ceil(Math.random() * 1000);

        // Set status to false to prevent multiple requests
        that.messageUpCycleData = {
          status: false,
          localId: messageRequestdata.localId,
        };

        // Fetch previous messages
        await that.UpdateMessageRequestData({ params: messageRequestdata });

        // Emit the request to join the room and fetch messages
        that.$socket.emit("getMessageofRoom", {
          request: messageRequestdata
        });
        console.log('messageRequestdata', messageRequestdata);
        setTimeout(()=>{
            // Calculate the scroll height after adding the new messages
          const scrollHeightAfterFetch = event.target.scrollHeight;

          // Calculate the difference in scroll height
          const scrollHeightDifference = scrollHeightAfterFetch - scrollHeightBeforeFetch;

          // Adjust the scroll position by the difference to keep the relative position
          // Set the scrollTop to its original position adjusted for the new data
          // We need to delay the scrollTop adjustment slightly to let the DOM update
          setTimeout(() => {
            // Adjust the scroll position by the difference to keep the relative position
            console.log( scrollPositionBeforeFetch + scrollHeightDifference);
            event.target.scrollTop = scrollPositionBeforeFetch + scrollHeightDifference;
          }, 0);
        },500);
      }
    },
    onSlideStart() {
      that.sliding = true;
    },
    onSlideEnd() {
      that.sliding = false;
    },
    setSlider(data) {
      that.sliderImages = data;
    },
    setImage(index) {
      that.slider = index;
    },
    //this fun is for to cancel edit
    cancelEdit() {
      that.updateMessage = {
        chatData: "",
        chatIndex: "",
        chatParentIndex: "",
        chatChildIndex: "",
        editMessage: false,
      };
      that.sendChat.message = "";
      const tiptapEditor = document.querySelector(".tiptap-editor");
      tiptapEditor.style.height = "50px";
    },
    // this fun is for to submit chat form according to need
    async submitform() {
      if (that.updateMessage.editMessage === true) {
        await that.updateMsg();
      } else {
        await that.setLocalmessageData();
      }
    },
    // this fun is for to update chat message
    async updateMsg() { 
      var checkcontent = that.canSendMessage(that.sendChat.message);
      var checkmsgEmpty = that.sendChat.message
        .replaceAll("&nbsp;", "")
        .replaceAll("<div><br></div>", "")
        .replaceAll(new RegExp(">[ ]+<", "g"), "><")
        .replaceAll("<div></div>", "")
        .trim(); 
        console.log('checkmsgEmpty',checkmsgEmpty);
      if (checkmsgEmpty != "" && checkcontent == false) {
          that.sendMsgStatus = 1;  
          let request = {
            chat_room_id: that.updateMessage.chatData.chat_room_id,
            chat_id: that.updateMessage.chatData.chat_id,
            sended_by: that.$store.state.currentUserData.login_master_id,
            type: that.updateMessage.chatData.type,
            message: that.sendChat.message,
          };
          await this.$socket.emit("sendMessage", request, (response) => {
            console.log('response==',response);
            if (response.success) {
              that.messagelist[that.updateMessage.chatIndex].value[
                that.updateMessage.chatParentIndex
              ].value[that.updateMessage.chatChildIndex].message = that.sendChat.message;
              that.sendChat.message = "";
              that.updateMessage = {
                chatData: "",
                chatIndex: "",
                chatParentIndex: "",
                chatChildIndex: "",
                editMessage: false,
              };
              console.log("updateMsg", response);
              that.updateMessage.editMessage = false;
              that.sendMsgStatus = 0;
            } else {
              console.log("updateMsg", response);
            }
          });
      }  
    },
    async rejectRequest() {
      (this.deleteParam = {
        chatData: "",
        chatIndex: "",
        chatParentIndex: "",
        chatChildIndex: "",
        chatEvent: "",
      }),
        this.$refs.callparentFunction.showModel(false);
    },
    // this fun is for to delete message set variable
    async deleteMsgSetVar(_i, index, parentindex, childindex, event, type) {
      this.deleteParam = {
        chatData: _i,
        chatIndex: index,
        chatParentIndex: parentindex,
        chatChildIndex: childindex,
        chatEvent: event,
        chatType: type,
      };
      this.$refs.callparentFunction.showModel(true);
    },
    // this fun is for to delete message
    async deleteMsg() {
      that.$socket.off("deleteChatMessage");
      // this fun is for to get chatroom member data from socket
      that.$socket.emit("deleteChatMessage", {param:this.deleteParam, chat_id : this.deleteParam.chatData,is_deleted:1,  deleted_by: that.$store.state.currentUserData.login_master_id} , async (data) => {
          console.log("deleteChatMessage-socket", data); 
            this.$refs.callparentFunction.showModel(false);
        
      });
      // this fun is for to get chatroom member data from socket
      that.$socket.on("deleteChatMessage", async (data) => {
          console.log("deleteChatMessage-socket-on", data); 
          this.$refs.callparentFunction.showModel(false);
      });
    },
    // this fun is for to delete message
    // async deleteFile(_i,index,parentindex,childindex,childchildindex){
    //     alert('Are you sure you want to delete this file?');
    //     var res = await that.genericAPIPOSTRequest({
    //         requestUrl  :'deleteMessage',
    //         params      : {
    //             'chat_id'       : _i,
    //             'is_deleted'    : 1,
    //             'deleted_by'    : that.$store.state.currentUserData.login_master_id,
    //         },
    //     });
    //     if (res ) {
    //         that.messagelist[index].value[parentindex].value[childindex].data.splice(childchildindex,1);
    //     }
    // },

    // this function is for to upload attachment
    async UploadFile(e) {
      console.log("preview_list==", this.preview_list);
      // Increment the total files uploading counter
      this.totalfilesuploading += e.target.files.length;
      if (this.totalfilesuploading < 11) {
        that.previewMultiImage(e);
        let error = 0;
        // Loop through the files
        for (let index = 0; index < e.target.files.length; index++) {
          const file = e.target.files[index];
          const ext = file.name.split(".").pop();
          // Check file extension
          if (
            [
              "pdf",
              "word",
              "png",
              "jpeg",
              "jpg",
              "xlsx",
              "xls",
              "docx",
              "doc",
              "csv",
              "zip",
              "rar",
            ].includes(ext)
          ) {
            const fileSize = file.size / 1024 / 1024; // in MiB
            if (fileSize <= 8) {
              let sended_by;
              // Determine 'sended_by' value based on account type
              if(that.$store.state.accountType == 'freelancer'){
                sended_by = that.$store.state.currentUserData.login_master_id;
              }else if(that.$store.state.accountType == 'client' && that.$store.state.listAccount.user != null && that.$store.state.listAccount.user != '' && that.$store.state.currentUserData.login_master_id == that.$store.state.listAccount.user.user_id){
                sended_by = that.$store.state.currentUserData.login_master_id;
              }else if(that.$store.state.accountType == 'agency' && that.$store.state.currentUserData.login_master_id == that.$store.state.listAccount.company.login_master_id){
                sended_by = that.$store.state.currentUserData.login_master_id;
              }else if(that.$store.state.accountType == 'client' && that.$store.state.listAccount.user != null && that.$store.state.listAccount.user != '' && that.$store.state.currentUserData.login_master_id != that.$store.state.listAccount.user.user_id){
                sended_by = that.$store.state.currentUserData.permission.user_id;
              }else if(that.$store.state.accountType == 'client' && that.$store.state.currentUserData.permission.user_id == that.$store.state.listAccount.qp_user.user_id){
                sended_by = that.$store.state.currentUserData.permission.user_id;
              }else if(that.$store.state.accountType == 'agency' && that.$store.state.currentUserData.login_master_id != that.$store.state.listAccount.company.login_master_id){
                sended_by = that.$store.state.currentUserData.permission.user_id;
              }

              const formData = new FormData();
              formData.append("image", file);
              formData.append("chat_room_id", that.getmessageparams.chat_room_id);
              formData.append(
                "user_id",
                that.$store.state.currentUserData.login_master_id
              );

              let url = `chat/chatmediaupload/${that.getmessageparams.chat_room_id}/${sended_by}`;
              if (
                this.chatroomdata.chat_invitation_id != undefined &&
                this.chatroomdata.chat_invitation_id != ""
              ) {
                formData.append(
                  "chat_invitation_id",
                  this.chatroomdata.chat_invitation_id
                );
                url = `chat/chatmediaupload/${that.getmessageparams.chat_room_id}/${sended_by}/${this.chatroomdata.chat_invitation_id}`;
              }

              try {

                // Upload the file using genericAPIPOSTForNodeFormDataWithProgress
                const getData = await that.genericAPIPOSTForNodeFormDataWithProgress({
                  requestUrl: url,
                  params: formData,
                  onProgress: (progress, uploadedSize) => {
                    // Update the progress bar and uploaded size for the specific file
                    that.preview_list.forEach((data, pindex) => {
                      if (data.name === file.name) {
                      // $("#uploaded-err_" + pindex).hide();  // hide error box
                      // $("#uploading-success-container_" + pindex).hide();
                        data.successStatus = progress; // Update progress percentage
                        data.uploadedSizeMB = uploadedSize / (1024 * 1024); // Convert bytes to MB

                        const backgroundStyle = `linear-gradient(to right, #ddd ${progress}%, #f5f5f5 ${progress}%)`;
                        $("#progressbar_" + pindex).css("background", backgroundStyle);
                        $("#uploaded-size_" + pindex).text(
                          that._f("sizeInMb")(uploadedSize)
                        );
                        if (progress === 100) {
                          // $("#progressbar" + pindex).addClass("your-class-name").show();
                        }
                      }
                    });
                  },
                });

                if (!getData || !getData.filename) {
                  console.log("Error uploading, "+file.name)
                  console.log("I am here",that.preview_list[index])
                  // that.preview_list[index].isuploaded = 0; // Mark upload failed
                  throw new Error(`File ${file.name} upload failed`);
                }
                if (getData.filename != "") {
                  // File successfully uploaded
                  const uploadedFile = getData;
                  uploadedFile.is_type = ext;
                  that.sendChat.mediaData.push(uploadedFile);

                  // Mark file as uploaded
                  that.preview_list.forEach((data, pindex) => {
                    if (data.name === file.name) {
                      that.preview_list[pindex].isuploaded = 1;
                    }
                  });

                  that.uploadRecentfiles.file_path = uploadedFile.uploadPath;
                  that.uploadRecentfiles.chat_room_id =
                    that.getmessageparams.chat_room_id;
                  that.filesuploadcount++;
                } else {
                  // File upload failed
                  that.preview_list.splice(index, 1);
                  that.image_list.splice(index, 1);
                  error++;
                }
              }catch (err) {
                  console.error(`Error uploading file ${file.name}:`, err);
                  // Find the correct index of the failed file
                  const failedFileIndex = that.preview_list.findIndex(data => data.name === file.name);
                  if (failedFileIndex !== -1) {
                    console.log("Updating isuploaded for:", failedFileIndex);                  
                    // Vue reactivity fix
                    that.$set(that.preview_list, failedFileIndex, {
                      ...that.preview_list[failedFileIndex],
                      isuploaded: 0
                    });                  
                    console.log("Updated preview_list:", that.preview_list);
                  } else {
                    console.warn("Failed file not found in preview_list");
                  }
                0}
            }
          } else {
            console.log("I am here")
             // Find the correct index of the failed file
            const failedFileIndex = that.preview_list.findIndex(data => data.name === file.name);
            if (failedFileIndex !== -1) {
              console.log("Updating isuploaded for:", failedFileIndex);
              // Vue reactivity fix
              that.$set(that.preview_list, failedFileIndex, {
                ...that.preview_list[failedFileIndex],
                isuploaded: 0
              });
            
              console.log("Updated preview_list:", that.preview_list);
            } else {
              console.warn("Failed file not found in preview_list");
             }
            that.$toastr.e("Invalid file type");
          }
        }

        if (error !== 0) {
          that.$toastr.e("Some files were not uploaded");
        }

        // Reset file input
        document.getElementById("fileUpload").value = "";
      } else {
        console.log("that.filesuploadcount", that.filesuploadcount);
        this.totalfilesuploading = this.totalfilesuploading - e.target.files.length;
        console.log("this.totalfilesuploading", this.totalfilesuploading);
        that.$toastr.e("At a time, only 10 files can be uploaded.");
      }
    },
    // this fun is for to preview the multiple image upload
    previewMultiImage: function (event) {
      var input = event.target;
      var count = input.files.length;
      if (input.files) {
        for (let index = 0; index < count; index++) {
          var files = event.target.files[index];
          const fileSize = files.size / 1024 / 1024; // in MiB
          if (fileSize <= 8) {
            var reader = new FileReader();
            reader.onload = (e) => {
              that.image_list.push(e.target.result);
            };
            input.files[index].isuploaded  = 2 ;
            input.files[index].successStatus = Math.floor(Math.random() * 70 + 1);
            that.preview_list.push(input.files[index]);
            reader.readAsDataURL(input.files[index]);
          } else {
            this.totalfilesuploading = this.totalfilesuploading - 1;
            that.$toastr.e("File Size Should be Less Than 8 Mb");
          }
        }

        const element = document.querySelector(".up-d-composer-attachment");
        const height = element ? element.offsetHeight : 0; // Get height or 0 if not found
        console.log("height=", height);

        const tiptapeditorHeight = document.querySelector(".tiptap-editor");
        const tiptopStyle = window.getComputedStyle(tiptapeditorHeight);
        this.tipTopHeight = parseFloat(tiptopStyle.height); // Get the current bottom value
        console.log("conversationBottom=", this.tipTopHeight); // Output the value (e.g., '0px')
        let contentHeight = height + this.tipTopHeight;

        console.log("contentHeight=", contentHeight);
        let conversation = 0;
        if (contentHeight > 0) {
          conversation = contentHeight;
        }
        this.conversationHeight = conversation - 50;
        //alert('sasassas');
        console.log(that.preview_list);
        //document.querySelector("#conversation").style.bottom = `${conversation - 50}px`;
        //document.querySelector("#typingtitle").style.bottom = `${conversation - 50}px`;
      }
    },
    // this fun is for to remove preview files and images
    removePrev(_i) {
      if (this.totalfilesuploading > 0) {
        this.totalfilesuploading -= 1;
        if (that.preview_list[_i]?.isuploaded === 1) {
          this.filesuploadcount -= 1;
        }
      }

      // Get the filename of the file being removed
      const removedFile = that.preview_list[_i]?.name;
      // Remove the file from the lists
      that.preview_list.splice(_i, 1);
      that.image_list.splice(_i, 1);
      that.sendChat.mediaData.splice(_i, 1);

      // Update UI elements dynamically after removal
      that.preview_list.forEach((data) => {
        if (data.isuploaded === 0) {
          console.log("Updating UI for failed file:", data.name);
          
          const errorElement = document.querySelector(`#uploaded-err_${data.name}`);
          if (errorElement) {
            errorElement.textContent = "Invalid file type";
            errorElement.style.color = "red";
          }

          const progressBar = document.querySelector(`#progressbar_${data.name}`);
          if (progressBar) {
            progressBar.style.background = "#ff00001a";
          }

          const uploadingStatusContainer = document.querySelector(`#uploading-status-container_${data.name}`);
          if (uploadingStatusContainer) {
            uploadingStatusContainer.style.display = "none";
          }
        }
      });

      // Remove the error element of the deleted file if it exists
      if (removedFile) {
        console.log('_as',_i)
        console.log('html',$(`#remove-preview-file-${_i}`).html())
        $(`.remove-preview-file-${_i}`).remove()
      }

    },
    // this fun is for to choose file
    chooseFiles() {
      document.getElementById("fileUpload").value = "";
      document.getElementById("fileUpload").click();
    },
    // this fun is for to add emoji to message
    insert(emoji) {
      const editor = this.$refs.editor.editor; // Access the Tiptap editor instance
      if (editor) {
        // console.log("Editor is available, inserting emoji>>>>", emoji);
        editor.chain().focus().insertContent(emoji).run();
        console.log('Editor content:', editor.getHTML());
      } else {
        console.log("Editor instance is not available");
      }
    },
    // this fun is for to set get message id
    async getselectedRoommessage(m_cycle) {
      console.log("getselectedRoommessage", m_cycle);
      that.messageUpCycleData = { status : true, localId : 0 };
      that.EmptyMessageData({ params: [] });
      that.sendChat.message = "";
      that.getmessageCycleNew = null;
      that.previousScrollPosition = 0;
      that.chatLoader = true;
      that.messagelist = [];
      that.localStorageMessageList = [];
      that.getmessageparams.chat_room_id = that.chatroomdata.chat_room_id;
      that.getmessageparams.start_limit = 0;
      that.totalMessageCount = 0;
      // Fetch previous messages
      await that.UpdateMessageRequestData({ params: {
          chat_room_id  : that.chatroomdata.chat_room_id,
          start_limit   : 0,
          end_limit     : 20,
          cycle         : m_cycle,
          lastId        : "",
          firstId       : "",
        }
      });
      // Remove any existing listener for 'chatHistory'
      that.$socket.off("chatHistory");
      // Emit the request to join the room and fetch messages
      that.$socket.emit("getMessageofRoom", {
        request : {
          chat_room_id  : that.chatroomdata.chat_room_id,
          start_limit   : 0,
          end_limit     : 20,
          cycle         : m_cycle,
          lastId        : "",
          firstId       : "",
        },
      });
      // Add a new listener scoped to this room
      that.$socket.on("chatHistory", async (history) => {
        console.log("getselectedRoommessage-history",that.chatroomdata.chat_room_id, history,history.count,that.totalMessageCount);
        that.totalMessageCount = parseInt(that.totalMessageCount) + parseInt(history.count);
        if (history != "" && history != null && history != undefined) {
          if(history.cycle == "recurring"  && history.localId != ''){
            if (parseInt(history.chat_room_id) === parseInt(that.chatroomdata.chat_room_id)) {
              // Ensure messages are for the correct room
              // console.log("chatbox-index-history", history);
              const index = that.localStorageMessageList.findIndex(data => {
                if (data.type === 1) {
                    return data.localId === history.localId;
                }
                return false;
              });

              // Remove the entire object if type === 1
              if (index !== -1) {
                console.log('index',index)
                // setTimeout(() => {
                  // that.localStorageMessageList.splice(index, 1); // Remove the matching element
                  // that.localStorageMessageList[index].is_sended = 2; // Remove the matching element
                  that.$set(that.localStorageMessageList[index], 'is_sended', 2);
                  // }, 100);
                setTimeout(async () => {
                  await this.checkLocalMessageArray();
                }, 100);
                that.chatdataResponse = history;
                that.getmessageCycleNew = history.cycle;
              } else {
                let removeAnyData = 0;
                console.log('Existing Messages:', that.localStorageMessageList);
                // If type > 1, find and remove matching item inside data.value array
                that.localStorageMessageList.forEach((val, index) => {
                  if (val.type > 1) {
                    console.log('val.data.length', val.data.length,val.type);
                    // Case 1: If data array has multiple elements
                    if (val.data.length > 1) {
                      const valueIndex = val.data.findIndex(item => item.localId === history.localId);
                      console.log('Removing from nested array, index:', valueIndex);
                      if (valueIndex !== -1) {
                        removeAnyData++;
                        val.data.splice(valueIndex, 1); // Remove the matched message after delay
                        // console.log('val.data-2',val.data);
                        that.chatdataResponse = history;
                        that.getmessageCycleNew = history.cycle;
                      }
                    } 
                    // Case 2: If data array has only one element, remove the entire object
                    else {
                      console.log('aliakbar', val.data[0].localId);
                      if (val.data[0].localId === history.localId) {
                        removeAnyData++;
                        that.localStorageMessageList.splice(index, 1); // Remove the whole object after delay
                        that.chatdataResponse = history;
                        that.getmessageCycleNew = history.cycle;
                      }
                    }
                  }
                });
                
                // console.log('after removing local value',that.localStorageMessageList,removeAnyData)
                if (removeAnyData === 0) {
                  that.chatdataResponse = history;
                  that.getmessageCycleNew = history.cycle;
                }
              }
            }
          }
          else if(history.cycle == "up"  && history.localId != '') {
            if (parseInt(history.chat_room_id) === parseInt(that.chatroomdata.chat_room_id)) {
              if(that.messageUpCycleData.localId == history.localId){
                that.messageUpCycleData = {
                  status: true,
                  localId : 0,
                }
                // console.log("chatbox-index-history", history);
                that.chatdataResponse = history;
                that.getmessageCycleNew = history.cycle;
              }
            }
          }
          else{
            if (parseInt(history.chat_room_id) === parseInt(that.chatroomdata.chat_room_id)) {
              // Ensure messages are for the correct room
              // console.log("chatbox-index-history", history);
              that.chatdataResponse = history;
              that.getmessageCycleNew = history.cycle;
            }
          }
          that.$emit("refreshFiles");
        } else {
          that.UpdateChatRoomResponse(true);
          // console.log("getselectedRoommessage-history-else",that.chatroomdata.chat_room_id, that.chatLoader);
          that.chatLoader = false;
          that.messageUpCycleData = {
            status : true,
            localId : 0,
          };
        }
      });
    },
    async checkLocalMessageArray() {
  console.log('localStorageMessageList changed');

  this.localStorageMessageList.forEach((data, index) => {
    // Only apply logic for type: 1
    if (data.type === 1) {
      let prev = null;
      let next = null;

      // Find the previous type 1 object
      for (let i = index - 1; i >= 0; i--) {
        if (this.localStorageMessageList[i].type === 1) {
          prev = this.localStorageMessageList[i];
          break;
        }
      }

      // Find the next type 1 object
      for (let i = index + 1; i < this.localStorageMessageList.length; i++) {
        if (this.localStorageMessageList[i].type === 1) {
          next = this.localStorageMessageList[i];
          break;
        }
      }

      // Check conditions and update is_sended
      if (prev && next && prev.is_sended === 2 && data.is_sended === 0 && next.is_sended === 2) {
        console.log(`Updating is_sended to 2 for localId: ${data.localId}`);
        this.$set(this.localStorageMessageList, index, { ...data, is_sended: 2 });
      }
    }
  });

  console.log('Final Updated List:', this.localStorageMessageList);
},

    // this fun is for to get messages
    async readMessages(_v,invite_id = null){
      var user_id;
      if(that.$store.state.accountType == 'freelancer'){
          user_id = that.$store.state.currentUserData.login_master_id;
      }else if(that.$store.state.accountType == 'client' && that.$store.state.listAccount.user != null && that.$store.state.listAccount.user != '' && that.$store.state.currentUserData.login_master_id == that.$store.state.listAccount.user.user_id){
          user_id = that.$store.state.currentUserData.login_master_id;
      }else if(that.$store.state.accountType == 'agency' && that.$store.state.currentUserData.login_master_id == that.$store.state.listAccount.company.login_master_id){
          user_id = that.$store.state.currentUserData.login_master_id;
      }else if(that.$store.state.accountType == 'client' && that.$store.state.listAccount.user != null && that.$store.state.listAccount.user != '' && that.$store.state.currentUserData.login_master_id != that.$store.state.listAccount.user.user_id){
          user_id = that.$store.state.currentUserData.permission.user_id;
      }else if(that.$store.state.accountType == 'client' && that.$store.state.currentUserData.permission.user_id == that.$store.state.listAccount.qp_user.user_id){
          user_id = that.$store.state.currentUserData.permission.user_id;
      }else if(that.$store.state.accountType == 'agency' && that.$store.state.currentUserData.login_master_id != that.$store.state.listAccount.company.login_master_id){
          user_id = that.$store.state.currentUserData.permission.user_id;
      }
      const request = {
          luid            : user_id,
          chat_room_id    : _v,
          // chat_room_id    : that.getmessageparams.chat_room_id,
      };
      if (invite_id != undefined && invite_id != null) {
          request.chat_invitation_id = invite_id;
      }
      var totalUnreadMessage = this.chatroomdata.unreadMessage;

      console.log('totalUnreadMessage',totalUnreadMessage)
      // this fun is for to emit read message from socket
      await this.$socket.emit('readMessage',request,(response) => {
        console.log('response-read',response)
        if (response.success) {
              if (totalUnreadMessage > 0) {
                // alert('asd')
                  var companyListData = that.$store.state.listAccount;
                  if (that.$store.state.accountType == 'freelancer') {
                    // alert('qp_user')
                    // qp_user
                    if (companyListData.qp_user != null && companyListData.qp_user != '' &&  companyListData?.qp_user?.UnreadChatRoom > 0) {
                      companyListData.qp_user.UnreadChatRoom = parseInt(companyListData?.qp_user?.UnreadChatRoom) - parseInt(totalUnreadMessage);
                    }
                  } else if(that.$store.state.accountType == 'agency' && companyListData?.company != null && companyListData?.company != '' && that.$store.state.currentUserData.login_master_id == companyListData.company.login_master_id) {
                    // alert('company')
                    // company
                    if(companyListData.company != null && companyListData.company != '' && that.$store.state.currentUserData.login_master_id == companyListData.company.login_master_id){
                      if(companyListData.company.UnreadChatRoom > 0){
                        companyListData.company.UnreadChatRoom = parseInt(companyListData?.company?.UnreadChatRoom) - parseInt(totalUnreadMessage);
                      }
                    }else{
                      console.log('agency-else');
                    }
                  } else if(that.$store.state.accountType == 'client' && companyListData?.user != null && companyListData?.user != '' && that.$store.state.currentUserData.login_master_id == companyListData.user.user_id) {
                    // alert('user')
                      // user
                      if(companyListData.user != null && companyListData.user != '' && that.$store.state.currentUserData.login_master_id == companyListData.user.user_id){
                          companyListData.user.UnreadChatRoom = parseInt(companyListData?.user?.UnreadChatRoom) - parseInt(totalUnreadMessage);
                      }else{
                          console.log('client-else');
                      }
                  }else if((that.$store.state.accountType == 'client' || that.$store.state.accountType == 'agency') && companyListData?.membersPermissionList.length > 0){
                    // alert('companyListData')  
                    companyListData?.membersPermissionList.map(data=>{
                      if (that.$store?.state?.currentUserData?.permission?.invited_team_id == data?.login_master_id && data?.UnreadChatRoom > 0) {
                          // console.log(data?.UnreadChatRoom)
                          data.UnreadChatRoom = parseInt(data?.UnreadChatRoom) - parseInt(totalUnreadMessage);
                      }
                    })
                  }
                  // console.log('companyListData',companyListData)
                  this.$store.commit('setListOfAccount', companyListData);
              }
              // chatroomdata.unread_message = 0;
              that.$emit('updateUnreadMessage');
              // console.log('readMessage',response);
          }else{
              console.log('readMessage-else',response);
          }
      })
    },
    // this fun is for to set messages in local state
    async setLocalmessageData() {
      var element = document.getElementById("conversation");
      var localUserData = that.permissionUserData()
      var checkcontent = that.canSendMessage(that.sendChat.message);
      var checkmsgEmpty = that.sendChat.message
        .replaceAll("&nbsp;", "")
        .replaceAll("<div><br></div>", "")
        .replaceAll(new RegExp(">[ ]+<", "g"), "><")
        .replaceAll("<div></div>", "")
        .trim();
      // console.log("that.$store.state.accountType", that.$store.state.accountType);
      // console.log("that.$store.state.currentUserData.permission",that.$store.state.currentUserData.permission);
      var sended_by;
      if (that.$store.state.accountType == "freelancer") {
        sended_by = that.$store.state.currentUserData.login_master_id;
      } else if ( that.$store.state.accountType == "client" && that.$store.state.listAccount.user != null && that.$store.state.listAccount.user != "" && that.$store.state.currentUserData.login_master_id == that.$store.state.listAccount.user.user_id) { 
        sended_by = that.$store.state.currentUserData.login_master_id;
      } else if ( that.$store.state.accountType == "agency" && that.$store.state.currentUserData.login_master_id == that.$store.state.listAccount.company.login_master_id) {
        sended_by = that.$store.state.currentUserData.login_master_id;
      } else if ( that.$store.state.accountType == "client" && that.$store.state.listAccount.user != null && that.$store.state.listAccount.user != "" && that.$store.state.currentUserData.login_master_id != that.$store.state.listAccount.user.user_id) {
        sended_by = that.$store.state.currentUserData.permission.user_id;
      } else if ( that.$store.state.accountType == "client" && that.$store.state.currentUserData.permission.user_id == that.$store.state.listAccount.qp_user.user_id) {
        sended_by = that.$store.state.currentUserData.permission.user_id;
      } else if ( that.$store.state.accountType == "agency" && that.$store.state.currentUserData.login_master_id != that.$store.state.listAccount.company.login_master_id ) {
        sended_by = that.$store.state.currentUserData.permission.user_id;
      }
      that.localMessageStucture.value.key = {
        "first_name": localUserData.first_name,
        "last_name": localUserData.last_name,
        "profile_picture_path": localUserData.profile_picture_path,
        "sended_by": sended_by,
        "time": moment(this.rawDate).toISOString(),
        "created_at": moment(this.rawDate).toISOString()
      }
      if (checkmsgEmpty != "" && checkcontent == false && that.sendMsgStatus == 0) {
        that.sendMsgStatus = 1;
        var sendRequest = {
          chat_room_id: that.getmessageparams.chat_room_id,
          sended_by: sended_by,
          type: 1,
          message: that.sendChat.message.trim(),
          localId : Math.ceil(Math.random()*1000),
        };
        console.log('sendRequest',sendRequest);

        if (this.chatroomdata.chat_invitation_id != undefined && this.chatroomdata.chat_invitation_id != "") {
          sendRequest.chat_invitation_id = this.chatroomdata.chat_invitation_id;
        }

        that.localStorageMessageList.push({
          ...sendRequest,
          is_deleted : 0,
          is_sended : 0,
        })
        setTimeout(() => {
          element.scrollTo({ top: element.scrollHeight + 10000, behavior: "smooth" });
        }, 500);
        that.sendChat.message = "";
        console.log("that.sendChat.message", that.sendChat.message);
        if (that.sendChat.mediaData.length > 0) {
          that.sendChat.mediaData.map(async (data, pindex) => {
            that.uploadRecentfiles.files.push({
              type: data.is_type,
              name: data.name,
              size: data.size,
            });
            if (data.is_type == "png" ||data.is_type == "jpeg" ||data.is_type == "jpg") {
              data.is_type = 1;
            } else if (data.is_type == "pdf" ||data.is_type == "word" ||data.is_type == "csv") {
              data.is_type = 3;
            }
            sendRequest = {
              ...sendRequest,
              type: data.is_type == 1 ? "2" : "3",
              message: data.name,
              localId : Math.ceil(Math.random()*1000),
              size: data.size,
              file_name: data.originalname,
              file_type: that.preview_list[pindex].type,
              parent_id: 0,
              // parent_id: response.newChatId,
            };
            if(that.localStorageMessageList.length > 0){
              console.log('lastocal store value',that.localStorageMessageList[that.localStorageMessageList.length - 1]);
              var lastLocalvalue = that.localStorageMessageList[that.localStorageMessageList.length - 1];
              if(lastLocalvalue.type == sendRequest.type){
                that.localStorageMessageList[that.localStorageMessageList.length - 1].data.push({
                  ...sendRequest,
                  is_deleted  : 0,
                  thumb       : data.thumbfilename,
                  media       : data.filename,
                });
              }else {
                that.localStorageMessageList.push({
                  data : [{
                    ...sendRequest,
                    is_deleted  : 0,
                    thumb       : data.thumbfilename,
                    media       : data.filename,
                  }],
                  type : sendRequest.type
                });
              }
            }else{
              that.localStorageMessageList.push({
                data : [{
                  ...sendRequest,
                  is_deleted  : 0,
                  thumb       : data.thumbfilename,
                  media       : data.filename,
                }],
                type : sendRequest.type
              });
            }
            setTimeout(() => {
              element.scrollTo({ top: element.scrollHeight + 10000, behavior: "smooth" });
            }, 500);
          });
          that.preview_list = [];
          that.image_list = [];
          that.sendChat.mediaData = [];
        }
        that.sendmessageData();
        that.filesuploadcount = 0;
        that.totalfilesuploading = 0;
        that.sendMsgStatus = 0;
        that.conversationHeight =  0;
        that.UpdateMessageCycleData("");
      } else if (that.sendChat.mediaData.length > 0 && that.sendMsgStatus == 0) {
        that.sendMsgStatus = 1;
        that.sendChat.mediaData.map(async (data, pindex) => {
          console.log('that.sendChat.mediaData',data)
          that.uploadRecentfiles.files.push({
            type: data.is_type,
            name: data.name,
            size: data.size,
          });
          if (data.is_type == "png" || data.is_type == "jpeg" || data.is_type == "jpg") {
            data.is_type = 1;
          } else if (data.is_type == "pdf" || data.is_type == "word") {
            data.is_type = 3;
          }
          var mediaSendRequest = {
            chat_room_id: that.getmessageparams.chat_room_id,
            sended_by: sended_by,
            type: data.is_type == 1 ? "2" : "3",
            size: data.size,
            file_name: data.originalname,
            message: data.name,
            file_type: that.preview_list[pindex].type,
            localId : Math.ceil(Math.random()*1000),
          };
          if (this.chatroomdata.chat_invitation_id != undefined && this.chatroomdata.chat_invitation_id != "") {
            mediaSendRequest.chat_invitation_id = this.chatroomdata.chat_invitation_id;
          }
          if(that.localStorageMessageList.length > 0){
            var lastLocalvalue = that.localStorageMessageList[that.localStorageMessageList.length - 1];
            if(lastLocalvalue.type == mediaSendRequest.type){
              that.localStorageMessageList[that.localStorageMessageList.length - 1].data.push({
                ...mediaSendRequest,
                is_deleted  : 0,
                is_sended   : 0,
                thumb       : data.thumbfilename,
                media       : data.filename,
                localId     : mediaSendRequest.localId,
              });
            }else {
              that.localStorageMessageList.push({
                data : [{
                  ...mediaSendRequest,
                  is_deleted  : 0,
                  is_sended   : 0,
                  thumb       : data.thumbfilename,
                  media       : data.filename,
                }],
                type : mediaSendRequest.type,
                localId     : mediaSendRequest.localId,
              });
            }
          }else{
            that.localStorageMessageList.push({
              data : [{
                ...mediaSendRequest,
                is_deleted  : 0,
                is_sended   : 0,
                thumb       : data.thumbfilename,
                media       : data.filename,
              }],
              type : mediaSendRequest.type
            });
          }
          setTimeout(() => {
            element.scrollTo({ top: element.scrollHeight + 10000, behavior: "smooth" });
          }, 500);
          console.log('sendMessage',that.localStorageMessageList,data)
        });
        that.sendmessageData();
        that.sendMsgStatus = 0;
        that.filesuploadcount = 0;
        that.totalfilesuploading = 0;
        that.preview_list = [];
        that.image_list = [];
        that.sendChat.mediaData = [];
        that.UpdateMessageCycleData("");
      }
    },

    async emptyInputValue(){
      that.sendChat.message = '';
    },
    // this fun is for to send messages
    async sendmessageData() {
       
      if(that.isOnline){
        const chat_room_id = that.chatroomdata.chat_room_id
        const user_id = that.$store.state.currentUserData.login_master_id
        const accountType = that.$store.state.accountType
        that.$socket.emit("stopTyping", { chat_room_id,user_id,accountType });
        console.log('that.localMessageStucture',that.localStorageMessageList)
        for (const [index, data] of this.localStorageMessageList.entries()) {
          console.log('data',data);
          if (data.is_sended == 0 && data.type == 1) {
            console.log('data.message-', index, data.message);
            // Await the socket emit response
            // await new Promise((resolve) => {
              // Mark as sending
              this.localStorageMessageList[index].is_sended = 1;
              this.$socket.emit("sendMessage", data, (res) => {
                if (res.success) {

                  console.log("sendMessage-if", res);
                } else {
                  console.log("sendMessage-else", res);
                }
                // resolve(); // Ensures the loop waits
              });
            // });
          }else if(data.type > 1){
            console.log('else-if-type',data)
            for (const [ind, childData] of data.data.entries()) {
              console.log('childData',childData,ind)
              // Await the socket emit response
              // await new Promise((resolve) => {
                this.localStorageMessageList[index].data[ind].is_sended = 1;
                this.$socket.emit("sendMessage", childData, (res) => {
                  if (res.success) {
                    // resolve();
                    console.log("sendMessage-if", res);
                  } else {
                    // resolve();
                    console.log("sendMessage-else", res);
                  }
                });
              // });
            }
            console.log('data.data',data)
          }
        }
        const tiptapEditor = document.querySelector(".tiptap-editor");
        tiptapEditor.style.height = "50px";
      }
    },
    async sendmessageData_11_03_2025() {
      var element = document.getElementById("conversation");
      var localUserData = that.permissionUserData()
      var checkcontent = that.canSendMessage(that.sendChat.message);
      var checkmsgEmpty = that.sendChat.message
        .replaceAll("&nbsp;", "")
        .replaceAll("<div><br></div>", "")
        .replaceAll(new RegExp(">[ ]+<", "g"), "><")
        .replaceAll("<div></div>", "")
        .trim();
      // replaceAll(" ", "").
      // return false;
      console.log("that.$store.state.accountType", that.$store.state.accountType);
      console.log("that.$store.state.currentUserData.permission",that.$store.state.currentUserData.permission);
      var sended_by;
      if (that.$store.state.accountType == "freelancer") {
        sended_by = that.$store.state.currentUserData.login_master_id;
      } else if ( that.$store.state.accountType == "client" && that.$store.state.listAccount.user != null && that.$store.state.listAccount.user != "" && that.$store.state.currentUserData.login_master_id == that.$store.state.listAccount.user.user_id) { 
        sended_by = that.$store.state.currentUserData.login_master_id;
      } else if ( that.$store.state.accountType == "agency" && that.$store.state.currentUserData.login_master_id == that.$store.state.listAccount.company.login_master_id) {
        sended_by = that.$store.state.currentUserData.login_master_id;
      } else if ( that.$store.state.accountType == "client" && that.$store.state.listAccount.user != null && that.$store.state.listAccount.user != "" && that.$store.state.currentUserData.login_master_id != that.$store.state.listAccount.user.user_id) {
        sended_by = that.$store.state.currentUserData.permission.user_id;
      } else if ( that.$store.state.accountType == "client" && that.$store.state.currentUserData.permission.user_id == that.$store.state.listAccount.qp_user.user_id) {
        sended_by = that.$store.state.currentUserData.permission.user_id;
      } else if ( that.$store.state.accountType == "agency" && that.$store.state.currentUserData.login_master_id != that.$store.state.listAccount.company.login_master_id ) {
        sended_by = that.$store.state.currentUserData.permission.user_id;
      }

      that.localMessageStucture.value.key = {
        "first_name": localUserData.first_name,
        "last_name": localUserData.last_name,
        "profile_picture_path": localUserData.profile_picture_path,
        "sended_by": sended_by,
        "time": moment(this.rawDate).toISOString(),
        "created_at": moment(this.rawDate).toISOString()
      }

      if (checkmsgEmpty != "" && checkcontent == false && that.sendMsgStatus == 0) {
        that.sendMsgStatus = 1;
        var sendRequest = {
          chat_room_id: that.getmessageparams.chat_room_id,
          sended_by: sended_by,
          type: 1,
          message: that.sendChat.message.trim(),
          localId : Math.ceil(Math.random()*1000),
        };
        console.log('sendRequest',sendRequest)
        if (this.chatroomdata.chat_invitation_id != undefined && this.chatroomdata.chat_invitation_id != "") {
          sendRequest.chat_invitation_id = this.chatroomdata.chat_invitation_id;
        }
        
        that.localStorageMessageList.push({
          ...sendRequest,
          is_deleted : 0
        })
        console.log("if-sendRequest", sendRequest,that.localStorageMessageList);
        setTimeout(() => {
          element.scrollTo({ top: element.scrollHeight + 10000, behavior: "smooth" });
        }, 500);
        that.sendChat.message = "";
        await this.$socket.emit("sendMessage", sendRequest, (response) => {
          if (response.success) {
            console.log("Message sent:", response);
            that.uploadRecentfiles.message = that.sendChat.message;
            that.sendChat.message = "";
            console.log("that.sendChat.message", that.sendChat.message);
            if (that.sendChat.mediaData.length > 0) {
              that.sendChat.mediaData.map(async (data, pindex) => {
                that.uploadRecentfiles.files.push({
                  type: data.is_type,
                  name: data.name,
                  size: data.size,
                });
                if (
                  data.is_type == "png" ||
                  data.is_type == "jpeg" ||
                  data.is_type == "jpg"
                ) {
                  data.is_type = 1;
                } else if (
                  data.is_type == "pdf" ||
                  data.is_type == "word" ||
                  data.is_type == "csv"
                ) {
                  data.is_type = 3;
                }
                sendRequest = {
                  chat_room_id: that.getmessageparams.chat_room_id,
                  sended_by: sended_by,
                  type: data.is_type == 1 ? "2" : "3",
                  size: data.size,
                  file_name: data.originalname,
                  message: data.name,
                  file_type: that.preview_list[pindex].type,
                  parent_id: response.newChatId,
                  localId : Math.ceil(Math.random()*1000),
                };
                
                if (
                  this.chatroomdata.chat_invitation_id != undefined &&
                  this.chatroomdata.chat_invitation_id != ""
                ) {
                  sendRequest.chat_invitation_id = this.chatroomdata.chat_invitation_id;
                }
                console.log("sendRequest", sendRequest);
                if(that.localStorageMessageList.length > 0){
                  console.log('lastocal store value',that.localStorageMessageList[that.localStorageMessageList.length - 1]);
                  var lastLocalvalue = that.localStorageMessageList[that.localStorageMessageList.length - 1];
                  if(lastLocalvalue.type == sendRequest.type){
                    that.localStorageMessageList[that.localStorageMessageList.length - 1].data.push({
                      ...sendRequest,
                      is_deleted  : 0,
                      thumb       : data.thumbfilename,
                      media       : data.filename,
                    });
                  }else {
                    that.localStorageMessageList.push({
                      data : [{
                        ...sendRequest,
                        is_deleted  : 0,
                        thumb       : data.thumbfilename,
                        media       : data.filename,
                      }],
                      type : sendRequest.type
                    });
                  }
                }else{
                  that.localStorageMessageList.push({
                    data : [{
                      ...sendRequest,
                      is_deleted  : 0,
                      thumb       : data.thumbfilename,
                      media       : data.filename,
                    }],
                    type : sendRequest.type
                  });
                }
                setTimeout(() => {
                  element.scrollTo({ top: element.scrollHeight + 10000, behavior: "smooth" });
                }, 500);
                await this.$socket.emit("sendMessage", sendRequest, (res) => {
                  if (res.success) {
                    // that.$emit('refreshFiles')
                    console.log("res-file-if", res);
                  } else {
                    console.log("res-file-else", res);
                  }
                });
              });
              // if(that.uploadRecentfiles.files.length > 0){
              //     // that.addRecentfiles();
              // }
              that.preview_list = [];
              that.image_list = [];
              that.sendChat.mediaData = [];
            
            }
            that.filesuploadcount = 0;
            that.totalfilesuploading = 0;
            that.sendMsgStatus = 0;
            this.conversationHeight =  0;
            //document.querySelector("#conversation").style.bottom = `${0}px`;
            //document.querySelector("#typingtitle").style.bottom = `${70}px`;

            that.UpdateMessageCycleData("");
          } else {
            console.error("Message failed:", response.error);
            that.sendMsgStatus = 0;
            that.UpdateMessageCycleData("");
          }
        });
      } else if (that.sendChat.mediaData.length > 0 && that.sendMsgStatus == 0) {
        that.sendMsgStatus = 1;
        that.sendChat.mediaData.map(async (data, pindex) => {
          that.uploadRecentfiles.files.push({
            type: data.is_type,
            name: data.name,
            size: data.size,
          });
          if (data.is_type == "png" || data.is_type == "jpeg" || data.is_type == "jpg") {
            data.is_type = 1;
          } else if (data.is_type == "pdf" || data.is_type == "word") {
            data.is_type = 3;
          }
          var sendRequest1 = {
            chat_room_id: that.getmessageparams.chat_room_id,
            sended_by: sended_by,
            type: data.is_type == 1 ? "2" : "3",
            size: data.size,
            file_name: data.originalname,
            message: data.name,
            file_type: that.preview_list[pindex].type,
            localId : Math.ceil(Math.random()*1000),
          };
          if (
            this.chatroomdata.chat_invitation_id != undefined &&
            this.chatroomdata.chat_invitation_id != ""
          ) {
            sendRequest1.chat_invitation_id = this.chatroomdata.chat_invitation_id;
          }

          if(that.localStorageMessageList.length > 0){
            var lastLocalvalue = that.localStorageMessageList[that.localStorageMessageList.length - 1];
            if(lastLocalvalue.type == sendRequest1.type){
              that.localStorageMessageList[that.localStorageMessageList.length - 1].data.push({
                ...sendRequest1,
                is_deleted  : 0,
                thumb       : data.thumbfilename,
                media       : data.filename,
                localId     : sendRequest1.localId,
              });
            }else {
              that.localStorageMessageList.push({
                data : [{
                  ...sendRequest1,
                  is_deleted  : 0,
                  thumb       : data.thumbfilename,
                  media       : data.filename,
                }],
                type : sendRequest1.type,
                localId     : sendRequest1.localId,
              });
            }
          }else{
            that.localStorageMessageList.push({
              data : [{
                ...sendRequest1,
                is_deleted  : 0,
                thumb       : data.thumbfilename,
                media       : data.filename,
              }],
              type : sendRequest1.type
            });
          }
          setTimeout(() => {
            element.scrollTo({ top: element.scrollHeight + 10000, behavior: "smooth" });
          }, 500);
          console.log('sendMessage',that.localStorageMessageList,data)
          await this.$socket.emit("sendMessage", sendRequest1, (res) => {
            if (res.success) {
              // that.$emit('refreshFiles')
              console.log("res-file-if", res);
            } else {
              console.log("res-file-else", res);
            }
          });
        });
        that.sendMsgStatus = 0;
        if (that.uploadRecentfiles.files.length > 0) {
          // that.addRecentfiles();
        }
        that.filesuploadcount = 0;
        that.totalfilesuploading = 0;
        that.preview_list = [];
        that.image_list = [];
        that.sendChat.mediaData = [];
        that.UpdateMessageCycleData("");
      }
    },
    // this fun is for to add recent files to database
    async addRecentfiles() {
      var res = await that.genericAPIPOSTRequest({
        requestUrl: "addContractfiles",
        params: {
          files: that.uploadRecentfiles.files,
          file_path: that.uploadRecentfiles.file_path,
          message: that.uploadRecentfiles.message,
          chat_room_id: that.uploadRecentfiles.chat_room_id,
          type: "Chat-Files",
        },
      });
      if (res) {
        that.uploadRecentfiles = {
          job_application_id: "",
          message: "",
          file_path: "",
          files: [],
        };
      }
    },
    // function to detect if the content is empty
    isContentEmpty(text) {
      text = text
        .replaceAll("&nbsp;", "")
        // replaceAll(" ", "").
        .replaceAll("<div><br></div>", "")
        .replaceAll(new RegExp(">[ ]+<", "g"), "><")
        .replaceAll("<div></div>", "")
        .trim();
      return text.length == 0 ? true : false;
    },
    // function to refresh chat messages
    async refreshChatMessage() {
      that.previousScrollPosition = 0;
      that.messagelist = [];
      that.getmessageparams.chat_room_id = "";
      that.getmessageparams.start_limit = 0;
      that.EmptyMessageData({ params: [] });
      await that.UpdateMessageRequestData({
        params: {
          chat_room_id: "",
          start_limit: 0,
          end_limit: 20,
          cycle: "first",
          lastId: "",
          firstId: "",
        },
      });
      // that.getmessageDataLoad(that.messageCycle);
    },
    // this fun is for to get onload connection for socket
    onloadConnection() {
      this.$socket.on("userTyping", ({ user_id, isTyping }) => {
        // console.log("user_id, isTyping", user_id, isTyping);
        if (isTyping) {
          // Add the user to the typing list
          this.$set(this.typingUsers, user_id, true);
        } else {
          // Remove the user from the typing list
          this.$delete(this.typingUsers, user_id);
        }
      });
      this.$socket.on("deleteChatMessageRander", async (data) => {
          // console.log("deleteChatMessageRander-socket-on");
          let chatIdToFind = data.result.chat_id;
          let chatIndex = -1;
          let chatParentIndex = -1;
          let chatChildIndex = -1;

          that.messagelist.forEach((dateGroup, i) => {
              dateGroup.value.forEach((parent, j) => {
                  parent.value.forEach((message, k) => {
                      if (message.chat_id === chatIdToFind) {
                          chatIndex = i;
                          chatParentIndex = j;
                          chatChildIndex = k;
                      }
                  });
              });
          });
          // If found, update the message
          if (chatIndex !== -1 && chatParentIndex !== -1 && chatChildIndex !== -1) {
              that.messagelist[chatIndex].value[chatParentIndex].value[chatChildIndex].message = 
              (data.result.sended_by ==
                            this.$store.state.currentUserData.login_master_id
                              ? '<span class="bg-grey p-2 br-10 text-muted"><i>You removed this message</i></span>'
                              : '<span class="bg-grey p-2 br-10 text-muted"><i>Message Was Removed</i></span>');
               
              that.messagelist[chatIndex].value[chatParentIndex].value[chatChildIndex].is_deleted = data.result.is_deleted;
              that.messagelist[chatIndex].value[chatParentIndex].value[chatChildIndex].updated_at = data.result.updated_at;
          }
          
      });
      this.$socket.on("editChatMessageRander", async (data) => {
        console.log('data.result',data.result);
          // console.log("editChatMessageRander-socket-on");
          let chatIdToFind = data.result.chat_id;
          let chatIndex = -1;
          let chatParentIndex = -1;
          let chatChildIndex = -1;

          that.messagelist.forEach((dateGroup, i) => {
              dateGroup.value.forEach((parent, j) => {
                  parent.value.forEach((message, k) => {
                      if (message.chat_id === chatIdToFind) {
                          chatIndex = i;
                          chatParentIndex = j;
                          chatChildIndex = k;
                      }
                  });
              });
          });
          // If found, update the message
          if (chatIndex !== -1 && chatParentIndex !== -1 && chatChildIndex !== -1) {
              that.messagelist[chatIndex].value[chatParentIndex].value[chatChildIndex].message = data.result.message;
              that.messagelist[chatIndex].value[chatParentIndex].value[chatChildIndex].is_updated = data.result.is_updated;
              that.messagelist[chatIndex].value[chatParentIndex].value[chatChildIndex].updated_at = data.result.updated_at;
          }
      });
    },
  },
  watch: {
    conversationHeight(newVal) {
      this.conversationHeight = newVal;
      console.log("Received conversation height in parent:", newVal);
    },
    // this fun is for to check socket was connected or not
    "$store.state.socketConnected"(newStatus) {
      // alert(newStatus)
      if (newStatus) {
        const chat_room_id = that.chatroomdata.chat_room_id;
        const chatRoom = `chatRoom:${chat_room_id}`;
        if (chatRoom) {
          this.$socket.emit("joinRoom", { room: chatRoom });
        }
        this.sendmessageData();
      } else {
        console.warn("Socket disconnected. Handle reconnection logic here.");
      }
    },
    // this fun iis for to check inernet connectivity
    async isOnline(newValue, oldValue) {
      console.log('oldValue',oldValue,that.$socket);
      if (newValue) {
        if (that.$socket && that.$socket.disconnected) {
          that.reconnectSocket();
        }else if(that.$socket && that.$socket.connected ){
          that.sendmessageData();
        }
      }
    },
    // this fun is for to check chatdataresponse
    async chatdataResponse() {
      console.log('asdasd-aliakbar',this.chatdataResponse)
      if (this.chatdataResponse.cycle == "first") {
        await that.UpdateMessageRequestData({
          params: {
            chat_room_id: this.chatdataResponse.chat_room_id,
            start_limit: 0,
            end_limit: 20,
            cycle: this.chatdataResponse.cycle,
            lastId: this.chatdataResponse.last_id,
            firstId: this.chatdataResponse.first_id,
          },
        });
        await this.EmptyMessageData({ params: [] });
        await this.fetchChatfromSocket({ params: this.chatdataResponse });
      }else if (this.chatdataResponse.cycle == "up"){
        await that.UpdateMessageRequestData({
          params: {
            chat_room_id: this.chatdataResponse.chat_room_id,
            start_limit: 0,
            end_limit: 20,
            cycle: this.chatdataResponse.cycle,
            lastId: this.chatdataResponse.last_id,
            firstId: this.chatdataResponse.first_id,
          },
        });
        await this.fetchChatfromSocket({ params: this.chatdataResponse });
      } else if (this.chatdataResponse.cycle == "recurring") {
        await this.fetchChatfromSocket({ params: this.chatdataResponse });
        var element = document.getElementById("conversation");
        setTimeout(() => {
          element.scrollTo({ top: element.scrollHeight + 10000, behavior: "smooth" });
        }, 1000);
      } 
    },
    // this fun is for to check user is online or offline
    roomlist() {
      var res = that.roomlist.filter((data) => {
        return data.chat_room_id === that.chatroomdata.chat_room_id;
      });
      if (res.length > 0) {
        that.readMessages(
          that.chatroomdata.chat_room_id,
          that.chatroomdata.chat_invitation_id
        );
        res[0].onlineData.map((data) => {
          var elements = document.getElementsByClassName(
            "status-" + data.login_master_id
          );
          const response = that.checkUserOnlineOrOffline(data);
          if (response == true) {
            for (var i = 0; i < elements.length; i++) {
              elements[i].classList.add("bg-success");
            }
          } else {
            for (var ii = 0; ii < elements.length; ii++) {
              elements[ii].classList.remove("bg-success");
            }
          }
        });
      }
    },
    // this fun is for to watch chat data
    getmChatData() {
      this.filesuploadcount = 0;
      this.totalfilesuploading = 0;
      // console.log('that.getmChatData',that.getmessageCycle,that.getmChatData);
      if (that.getmChatData.length > 0) {
        that.messagelist = that.getmChatData;
        if (that.getmessageCycle == "first") {
          // that.chatLoader = false;
          // this.UpdateChatLoaderStatus({param:false});
          // that.readMessages(that.chatroomdata.chat_room_id);
        }
      } else {
        that.preview_list = [];
        that.messagelist = [];
      }
    },
    // this fun is for to watch message cycle
    getmessageCycleNew() {
      var element = document.getElementById("conversation");
      if (that.getmessageCycleNew == "first") { 
        setTimeout(() => {
          element.scrollTo({ top: element.scrollHeight + 10000, behavior: "smooth" });
          setTimeout(() => {
            that.UpdateChatRoomResponse(true);
            that.chatLoader = false;
            that.readMessages(
              that.chatroomdata.chat_room_id,
              that.chatroomdata.chat_invitation_id
            );
            setTimeout(() =>  { 
              if (element) {
                element.scrollTop = element.scrollHeight;
              }
            }, 100);
          }, 1000);
          that.previousScrollPosition = element.scrollHeight;
        }, 1000);
      } else if (that.getmessageCycleNew == "recurring") {
        setTimeout(() => {
          element.scrollTo({ top: element.scrollHeight + 10000, behavior: "smooth" });
          that.previousScrollPosition = element.scrollHeight;
          // that.readMessages(that.chatroomdata.chat_room_id);
        }, 1000);
      } else if (that.getmessageCycleNew == "up") {
        // console.log('up-cycle',that.getmessageCycle)
        setTimeout(() => {
          element.scrollTo({
            top: element.scrollHeight - that.previousScrollPosition,
            behavior: "smooth",
          });
          that.previousScrollPosition =
            element.scrollHeight - that.previousScrollPosition;
        }, 1000);
      }
    },
  },
  component: {
    TiptapEditor,
  },
  computed: {
    ...mapGetters("global", ["getmChatData", "getmessageCycle", "getchatroomResponse"]),
    ...mapGetters({
      loaderHideShow: "global/getchatLoader",
      SetEnterBtnRole: "getenterBtnRole",
    }),

    // this fun is for to show name for local message user
    checklocalmessageArrayShowHide() {
      if(that.localStorageMessageList.length > 0){
        // Function to check is_sended !== 0 based on type
        const hasUnsentMessages = that.localStorageMessageList.some(msg => {
          if (msg.type == 1) {
            return msg.is_sended !== 2;
          } else if (msg.type > 1 && msg.data) {
            return msg.data.some(innerMsg => innerMsg.is_sended !== 2);
          }
          return false;
        });
        return hasUnsentMessages;
      }
      return true;
    },

    /// this fun is for to check internet connectivity
    isOnline() {
      return this.$store.state.internetConnection;
    },
    // this fun is for to show name for local message user
    nameImageShowForLocalMesage() {
      if(that.localStorageMessageList.length > 0){
        if(that.messagelist[that.messagelist.length - 1].value[that.messagelist[that.messagelist.length - 1].value.length - 1].key.sended_by != that.localMessageStucture.value.key.sended_by){
          return true;
        }
      }
      return false;
    },

    // this fun is for to formatte date
    formattedDate() {
      return moment(this.rawDate).toISOString();
    },
    // this fun is for to check user typing array is there any change
    typingUsersText() {
      const userIds = Object.keys(this.typingUsers);
      console.log("this.typingUsers", userIds);
      if (userIds.length === 0) return "";

      if (userIds.length === 1) {
        return `${userIds[0]} is typing...`;
      }
      if (userIds.length === 2) {
        return `${userIds[0]} and ${userIds[1]} is typing...`;
      }
      if (userIds.length > 2) {
        return `${userIds[0]},${userIds[1]} and ${userIds.length - 2} other is typing...`;
      }
      return "";
    },
    computedBottom() {
      return `${Math.min(this.tipTopHeight - 50, 50)}px`;
    },

  },
  filters: {
    sizeInMb(value) {
      let sizes = ["Bytes", "KB", "MB", "GB", "TB"];
      if (value == 0) return "0 Byte";
      let i = parseInt(Math.floor(Math.log(value) / Math.log(1024)));
      return Math.round(value / Math.pow(1024, i), 2) + " " + sizes[i];
    },
  },
};
</script>
<style>

.no-internet-connecion.updating-conversation{
    width: fit-content;
    margin: 15px auto 0;
    left: 0;
    right: 0;
    padding: 8px 17px;
    border-radius: 20px;
    background-color: #f2613c;
    color: #fff;
    font-weight: 600;
}

/* No internet disable uploader */
.no-internet{
  background: #00000024;
  pointer-events: none;
}

.no-internet-tooltip{
  color: #fff;
  padding: 10px 15px;
  font-weight: 600;
  font-size: 13px;
  background-color: #000;
  position: absolute;
  width: 165px;
  left: 0;
  right: 0;
  margin: 0 auto;
  opacity:0;
  z-index: 100;
  border-radius: 7px;
  top: -30px;
  transition: all 0.2s ease;
}
.no-internet-tooltip::before{
  position: absolute;
  left: 23px;
  margin: 0 auto;
  content: '';
  width: 0;
  height: 0;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-top: 14px solid #000;
  bottom: -8px;
  z-index: 1000;
  opacity: 0;
  transition: all 0.2s ease;
}

.no-internet-tooltip-wr:hover .no-internet-tooltip,
.no-internet-tooltip-wr:hover .no-internet-tooltip::before{
  opacity: 1;
}


/* Drag & Drop Overlay */
.drop-overlay {
  position: fixed;
  top: 0;
  margin: 0 auto;
  width: 50%;
  pointer-events: none;
  top: 9%;
  bottom: 0;
  left: 0;
  right: 0;
  border: 1px dashed #00000035;
  border-top: 0;
  background: #ffffffd4;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 18px;
  font-weight: bold;
  z-index: 100000;
  backdrop-filter: blur(1px);
  height: 100vh;
  bottom: 0;
}

.b-sidebar > .b-sidebar-body {
  overflow-y: hidden !important;
}
.b-sidebar > .b-sidebar-body {
  overflow-y: auto !important;
}
.chat-wrap .message-head {
  overflow: hidden;
}
.chat-wrap .conversation {
  border-right: 0px;
}
.chat-wrap .conversation {
  height: auto;
}
.chat-wrap .message-head {
  height: 100%;
}
#conversation {
  overflow-y: hidden !important;
  /* height:100%;*/
}
#conversation:hover {
  overflow-y: auto !important;
}
#conversation {
  /* height:390px;*/
  height: 100%;
  /* bottom: 10%; */
}



/* hrashikesh pandey 31/01/2025 */
.drop-file-container {
  background: #fff;
  padding: 13% 10%;
  border-radius: 15px;
  border: 1px dashed #f2613c;
  text-align: center;
  margin-top: -9%;
}
.drop-file-container figcaption {
  color: #00000095;
  font-size: 32px;
  line-height: 42px;
  font-weight: 500;
  margin-bottom: 10px;
}
.drop-file-container span {
  font-size: 18px;
  color: #00000065 !important;
  font-weight: 600;
}
.drop-file-container img {
  margin: 0 auto;
  transform: translateZ(1);
}

.no-internet-connecion{
  color: red;
  font-weight: 600;
  font-size: 16px;
  padding: 20px 0;
  text-align: center;
  position: absolute;
  top: 0;
  z-index: 1000;
  background-color: #efefef;
  display: block;
  width: 100%;
}

.align-center{
  background-color: #f2f2f2;
    height: 100%;
    z-index: 1;
    align-items: flex-end;
    /* z-index: 1000; */
    flex-wrap: nowrap;
    overflow-x: scroll;
    display: flex;
    margin: 0;
    padding:0;
    width: 100%;
    overflow-y: hidden;
}

.upload-success{
  display: none;
  font-weight: 600;
  font-size: 13px;
  color: #00000085 !important; 
  margin-left: 21%;
}


@media screen and (max-width: 1279px) {
  .drop-overlay{
    width: 100%;
  }
}
@media screen and (max-width: 480px) {
  .drop-file-container figcaption {
    font-size: 28px;
    line-height: 30px;
  }
  .drop-file-container {
    padding: 13% 10%;
  }
}
@media screen and (max-width: 414px) {
  
  .chat-input .reply .reply-send {
    top: 17px !important;
  }
  
  .navbar-main{
    box-shadow: 0 0 0 0 !important;
  }
  .up-d-composer-attachment{
    bottom: 7% !important;
    width: 100%;
  }
  .chat-input .r-sec{
    padding-top:0px !important;
    padding-bottom:5px !important;
  }
  /* #conversation{
   padding-bottom: 12% !important;
  } */
  .drop-file-container figcaption {
    font-size: 25px;
    line-height: 30px;
  }
  .align-center {
    /* height: 190px; */
    margin: 0px 0 ;
    padding: 0;
}
  .drop-file-container {
    padding: 10% 8%;
  }
  h4.upload-message-flag{
    position: static !important;
    margin-bottom: 0 !important;
  }
  .chat-input .reply{
    border-radius: 0 !important;
    background-color: #fff !important; 
  }
  .container-chat .chat-input {
        bottom: 0;
        max-height: initial !important;
        padding: 5px 0 10px !important;
        background: #fff !important;
        
  }
}
/* Hrashikesh Pandey 01/02/2025 */
.file-attachment {
  transition: 0.2s ease all;
  width: 270px;
}
.total-file-size{
  display: none;
}
.uploaded
.upload-success,
.uploaded
.total-file-size{
display: block;
}
.error{
  background-color: #ff00001a !important;
}
.upload-status{
  display: none;
}
.upload-err-msg{
  display: none;
}
.loading
.upload-status,
.error
.upload-err-msg{
  display: block;
}
.uploaded{
  background:#ddd;
}

.loading
.total-file-size,
.error
.upload-status,
.error
.total-file-size{
  display: none !important;
}
@keyframes rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.error .attachment-preview{
  background: transparent;
  position: relative;
}

.attachment-preview a{
  display: flex;
  align-items: center;
  justify-content: center;
}
.error
a.up-d-story-img.loaded{
  opacity: 0;
}
.error .attachment-preview::before{
    content: "";
    height: 100%;
    width: 100%;
    background-image: url("data:image/svg+xml,%3Csvg stroke='red' fill='red' stroke-width='0' viewBox='0 0 24 24' height='14px' width='14px' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11.001 10h2v5h-2zM11 16h2v2h-2z'%3E%3C/path%3E%3Cpath d='M13.768 4.2C13.42 3.545 12.742 3.138 12 3.138s-1.42.407-1.768 1.063L2.894 18.064a1.986 1.986 0 0 0 .054 1.968A1.984 1.984 0 0 0 4.661 21h14.678c.708 0 1.349-.362 1.714-.968a1.989 1.989 0 0 0 .054-1.968L13.768 4.2zM4.661 19 12 5.137 19.344 19H4.661z'%3E%3C/path%3E%3C/svg%3E");
    background-size: contain;
    background-repeat: no-repeat;
    position: absolute;
    top: 0;
    left: 0;
}

h4.upload-message-flag{
  font-size: 15px;
  background: #F2613C;
  color: #fff;
  padding: 10px;
  z-index: 1;
  border-radius: 10px 10px 0 0;
  margin-bottom: 0 !important;
  top: 0;
}
.up-d-composer-attachment{
  margin: 5px 0 0;
  padding-bottom: 10px;
  background-color: #fff;
}

.flag-link{
  text-decoration: underline !important;
  font-weight: 600;
  color:#fff !important;
}
.composer-attachment {
  width: 100% !important;
}

.remove-attachment{
  z-index: 10000;
}
.tiptap-editor{
  height: 50px;
}
.chat-input .reply-recording {
  border: 1px solid #00000025;
}
.up-d-story-img.loaded > div {
  display: flex;
  background: transparent !important;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin:  0;
}
.reply-send{
  top:4px !important;
}
.up-d-story-img.loaded img {
    border-radius: 0;
    object-fit: cover;
}

.retry-failed-no-internet-img{
  width: 239px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
}
.retry-failed-no-internet-img figure{
  padding: 4px;
  width: 66px !important;
  margin: 20px 50px;
  border: 4px solid red;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.retry-failed-no-internet-img svg{
  background: red;
  border-radius: 50%;
}
.retry-failed-no-internet-img
span.upload-tittle {
    font-size: 23px;
    font-weight: 600;
}
.retry-failed-no-internet-img
span.uplod-description {
  font-size: 15px;
    font-weight: 600;
    color: #17151a96 !important;
    margin-bottom: 20px;
}
.retry-failed-no-internet-img
figure{
  padding: 4px;
    width: 70px;
    margin: 20px 50px;
    border: 4px solid red;
    border-radius: 50%;
}
.retry-failed-no-internet-img
button{
    color: red;
    font-weight: 700;
    font-size: 14px;
    padding: 7px 25px;
    border-radius: 3px;
}
.retry-failed-no-internet-img
figure img{
  width: 100% !important;
    height: 100% !important;
    border-radius: 50% !important;
    padding: 10px;
    background: red;
}

.no-internet-image-message{
  display: none;
}
</style>
